function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "acac56ab-bcae-42fb-a182-d934e873c548",
  x1: 158.36228,
  y1: 837.35568,
  x2: 158.36228,
  y2: 581.61856,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53514,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "af87c047-8598-4a2f-9e25-5794c516a383",
  x1: 980.32402,
  y1: 824.8256,
  x2: 980.32402,
  y2: 557.00513,
  xlinkHref: "#acac56ab-bcae-42fb-a182-d934e873c548"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a0dd3877-a1bb-4f12-811d-37917980f015",
  x1: -1003.12709,
  y1: 469.49298,
  x2: -1003.12709,
  y2: 167.60673,
  gradientTransform: "matrix(-1, 0, 0, 1, -573.82483, 0)",
  xlinkHref: "#acac56ab-bcae-42fb-a182-d934e873c548"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1172,523.97061c0-71.09317-30.06488-133.884-75.99115-171.64q.94818-10.77543.96071-21.85478c0-115.42878-79.23652-209.00231-176.97972-209.00231-31.178,0-60.46625,9.53346-85.90725,26.24756C764.88916,94.72323,674.56135,62.64432,575.74105,62.64432c-160.79285,0-299.09895,84.92918-360.45927,206.71809-3.41-.23119-6.843-.36142-10.30206-.36142C107.23653,269.001,28,362.57451,28,478.00329c0,42.43773,10.72071,81.91248,29.12326,114.87784v.00018c0,103.8533,84.18973,188.043,188.043,188.043H998.23976A147.64474,147.64474,0,0,0,1145.8845,633.2796v-.00015C1162.44307,601.47574,1172,564.04314,1172,523.97061Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff",
  opacity: 0.1
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M679.5182,727.27055s-12.29046-8.10968-24.4726-2.34109c0,0,3.753,7.22847,19.17037,6.53944Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M681.02655,727.70445s3.73868,14.24235-5.63279,23.93033c0,0-5.64263-5.87339-.04451-20.255Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M696.35417,714.03184s-.907-12.11176-28.2547-8.09341c0,0-.12859,7.81394,9.47352,11.51682S691.565,718.03662,696.35417,714.03184Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M698.03757,713.95s11.56269,3.71774,1.25253,29.36431c0,0-7.62681-1.70463-8.97841-11.90684S693.02273,717.66837,698.03757,713.95Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M713.51992,696.76955s1.5641-19.93043-26.38128-17.88434c0,0-1.98509,18.038,21.44927,22.67559Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M731.98972,674.26986S728.1575,651.687,700.22161,658.418c0,0-.10487,19.52637,27.20633,21.236Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M745.4842,651.01011s-6.41431-22.04821-34.09368-15.41393c0,0,6.58621,19.78558,32.25678,19.4769Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M758.30591,628.29723s-6.2715-22.83468-32.98775-15.97773c0,0,8.91651,21.69016,31.23072,19.86405Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M766.57327,606.71668s-4.82174-27.92372-29.74239-21.74427c0,0,7.23936,25.39984,27.9055,25.80725Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M774.31812,580.64473s-5.78487-28.14639-30.97421-19.96083c0,0,9.88913,26.59781,29.21718,23.84716Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M779.116,556.37876s-9.18788-28.14253-28.6804-27.38106c0,0,9.39638,29.727,27.052,33.0285Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M782.1631,532.70393s-10.00014-33.88179-25.86286-31.26652c0,0,6.92284,25.895,25.29931,36.54345Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M783.89435,504.42229s-9.37151-28.23193-25.03322-29.35543c0,0,6.37776,27.77616,24.68654,36.69193Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M785.78993,478.09289s-11.68948-28.26279-22.03947-28.89967c0,0,5.07826,27.82693,21.006,33.53862Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M787.088,453.57426s-7.18589-30.69463-17.52371-33.24082c0,0,1.41461,25.10678,16.48547,35.53729Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M790.9744,421.48871s-7.55827-24.461-15.92686-28.19317c0,0,1.65393,28.843,13.98683,34.177Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M794.20846,400.41244l1.52515-43.13873s-15.62053,32.55637-2.6759,50.74869Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M806.29232,357.54182s11.26364-31.50211,13.97161-33.25645c0,0-22.09624,20.43465-19.93964,46.72792Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M714.28074,696.623s19.82265-2.59445,19.22694,25.4194c0,0-17.911,2.91684-23.75627-20.24582Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M732.92573,673.51639s22.90562-.07631,21.03873,28.59835c0,0-19.22227,3.43429-25.56577-23.185Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M745.70857,652.8668s20.79-9.749,34.09368,15.41393c0,0-19.20487,8.12531-35.93058-11.35095Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M758.76958,628.50686s21.28609-10.37575,33.7864,14.21121c0,0-22.17409,7.63393-35.54343-10.32489Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M766.29986,607.32143s20.4908-19.5732,36.84255.22186c0,0-20.932,16.1062-37.78385,4.13657Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M773.15573,579.97416s20.61668-20.0159,36.83729.92205c0,0-23.13874,16.42671-37.57094,3.27943Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M777.0127,555.579s15.88094-24.98429,34.57552-19.41191c0,0-16.47593,26.46752-34.39875,25.28677Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M781.69139,532.5463s16.01609-31.48751,31.135-26.021c0,0-11.53278,24.19654-31.54408,31.31214Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M782.79433,502.8163s16.45227-24.78285,31.85985-21.75667c0,0-13.44385,25.12875-33.45074,28.927Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M784.04925,477.53884s12.74736-27.80169,23.114-28.04766c0,0-6.1244,27.61555-22.25624,32.7223Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M786.57857,452.96991s14.16937-28.16072,24.816-28.217c0,0-7.25069,24.0786-24.344,30.69268Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M788.70875,423.21629s10.60093-23.30421,19.37544-25.9444c0,0-5.30033,28.4-18.21035,32.126Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M795.47014,399.59963,819.158,363.51416s-6.06893,35.59615-27.147,42.96078Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M811.73013,360.44478s27.53164-19.00688,28.52826-22.07568c0,0-14.04489,26.61879-40.00491,31.31605Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M813.37569,351.89919s31.61033-30.3881,39.68078-30.35631c0,0-26.06836,1.19264-40.43815,28.73734Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M789.01467,427.72676l1.15371.14761c5.93932-46.496,14.5992-73.97444,24.38478-77.37325l-.38151-1.09873C803.799,353.00513,795.09979,380.08932,789.01467,427.72676Z",
  transform: "translate(-28 -62.64432)",
  fill: "#444053"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M780.28219,538.899l1.73884.14661c.36535-4.34171.64738-8.78591.83771-13.20924,1.65753-38.48525,4.23017-73.82017,7.61456-100.31343l-1.00837-1.24567c-3.39052,26.54128-6.68978,62.95021-8.34935,101.48408C780.9261,530.16075,780.6458,534.58111,780.28219,538.899Z",
  transform: "translate(-28 -62.64432)",
  fill: "#444053"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M647.05729,749.40431c.30564-.1342,30.93385-13.80955,62.72365-46.43587A252.32356,252.32356,0,0,0,755.632,638.01258c14.69615-29.92513,23.65453-66.70932,26.66112-102.43764l-1.81334.85221c-6.74827,80.19385-43.26009,135.02267-72.29266,164.84337-31.48014,32.335-61.76375,45.8713-62.06589,46.004Z",
  transform: "translate(-28 -62.64432)",
  fill: "#444053"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M657.67553,364.76491V742.54684c0,11.23585-10.83659,20.37118-24.21729,20.37118H120.89193c-13.3807,0-24.21713-9.13533-24.21713-20.37118V364.76491c0-11.25569,10.83643-22.72706,24.21713-22.72706H633.45824C646.83894,342.03785,657.67553,353.50922,657.67553,364.76491Z",
  transform: "translate(-28 -62.64432)",
  fill: "#fff"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M657.67553,366.25513v59.38862H96.6748V366.25513a24.20965,24.20965,0,0,1,24.21713-24.21728H633.45824A24.20978,24.20978,0,0,1,657.67553,366.25513Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff",
  opacity: 0.2
});

var _ref42 = /*#__PURE__*/React.createElement("circle", {
  cx: 99.44102,
  cy: 321.19648,
  r: 16.19393,
  fill: "#fff"
});

var _ref43 = /*#__PURE__*/React.createElement("circle", {
  cx: 146.55622,
  cy: 321.19648,
  r: 16.19393,
  fill: "#fff"
});

var _ref44 = /*#__PURE__*/React.createElement("circle", {
  cx: 193.67142,
  cy: 321.19648,
  r: 16.19393,
  fill: "#fff"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M232.78342,762.22672s-15.65839,3.78875-21.8565,10.872a21.07939,21.07939,0,0,1-8.33523,5.29638V767.6835c3.58-6.01475,7.19348-12.70478,7.19348-12.70478.16311-.32945,1.468-4.94181,1.468-4.94181,2.93593-2.3062-.16311-10.37784-.16311-10.37784s1.79419-5.10656.81552-6.09492-.16311-3.624.65244-4.77709a5.96691,5.96691,0,0,0,.65244-3.624c0-.98839-1.30488-2.47092-3.42528-3.29456s.16311-2.14147,1.468-2.47092,1.63108-3.45928.1631-5.10656.1631-2.63564.97864-4.44764-2.60973-1.48252-2.60973-1.48252V691.72641l.00162-.0014s-.97864-5.436-1.95729-14.99351c-.97864-9.55253-4.73178-10.54089-4.73178-10.54089a42.69243,42.69243,0,0,1-5.87187-2.30787,40.188,40.188,0,0,0-6.19973-2.30286,31.78087,31.78087,0,0,1-7.99068-1.107,24.50869,24.50869,0,0,0-5.456-1.18112c-.2006-.09387-.39146-.19272-.58718-.29153a21.35407,21.35407,0,0,1-9.899-10.48657c-.10051-.22639-.19285-.4498-.28352-.67242a23.28862,23.28862,0,0,0,2.60779-3.45895l.01673-.02809c.00176.16811.00723.3364.00729.50442.00009.07067-.00234.14108-.00252.21172-.0015.40622-.00555.8123-.01669,1.21747l.00225-.00365-.00043.03583c2.6042-4.59687,10.14933-5.64632,10.86787-10.89244a5.49919,5.49919,0,0,0,.04749-.71938l.00089-.03262c0-.17691-.00833-.3537-.02121-.53041-.09749-1.46464-.59873-2.92335-.69651-4.40444a8.58073,8.58073,0,0,1,.02086-1.27058l.00252.02376c.33726-4.07567,3.41034-7.61842,4.81767-11.57657a14.18062,14.18062,0,0,0,.73442-3.29415l.00342-.02987q.05166-.50968.06911-1.02215c.00306-.08475.00315-.1694.0048-.25421q.00591-.35572-.00443-.71147a15.4134,15.4134,0,0,0-5.0914-11.13119c-2.60021-2.2604-6.037-3.6805-7.8369-6.63024-.83976-1.37623-1.25322-2.99334-2.16826-4.31974-1.7236-2.49842-4.89462-3.51627-7.88843-3.87755s-6.08071-.24018-8.94788-1.18225c-2.03155-.66751-3.87578-1.84745-5.92935-2.44219a11.34818,11.34818,0,0,0-12.18844,4.39495c-1.08248,1.57868-1.791,3.46963-3.24932,4.70189-2.98872,2.52542-8.05961,1.42939-10.67869,4.34353-1.43818,1.60017-1.60337,3.78042-1.42863,6.01133l.006.078q.02118.25928.04764.51877c.008.08055.016.1609.02465.24145.00947.08613.01948.172.02955.258.09229.79906.20807,1.59417.30844,2.36079.01531.11694.02685.23428.04089.35137.02839.2379.0562.47584.07955.71427.01711.17407.03155.34841.04593.52272q.02674.32394.04717.64825c.0108.16943.02228.33877.03059.50831a35.15846,35.15846,0,0,1-3.741,17.56888c-2.46732,4.8453-6.13759,9.30437-6.77658,14.71451a15.597,15.597,0,0,0-.07041,2.66849c.00539.1046.00759.20941.01479.31393.01135.16036.02859.32032.044.48043.01739.18372.03386.36749.05629.55089.013.10481.029.20941.04358.31413.03339.24361.0689.48706.11008.73023.00889.052.01881.10387.028.15581.64818,3.68716,2.11541,7.32592,2.89759,11.02524a30.54615,30.54615,0,0,1,.58316,4.16645l.00145.02882q.04649.66733.06392,1.33634c.0154.60344.00744,1.20709-.01261,1.81042a28.39159,28.39159,0,0,1-3.80187,1.16749c-2.28514.33111-8.97421,6.26131-8.48488,7.74384.48442,1.4628-2.99465,11.87521-3.09252,12.18162l-.00492.00491.00112.001-.00112.00064-5.5027,37.88733s-2.90575,2.80036-1.99769,4.61236-.17578,4.94181-.17578,4.94181-4.90929,2.14147-3.81963,3.45928.59239,3.78872-.15784,5.436-1.97393,4.6124,0,5.10656.33946,6.91856.33946,6.91856,6.88427-.79008,6.37861,3.29456c-.16151,1.30474,4.81509,4.88087,6.89289,6.31254v19.68008a60.23575,60.23575,0,0,1-8.15543-2.76605c-4.24079-1.97675-28.05462-5.76548-33.27408,5.60072S66.08686,811.645,69.1859,813.29225c0,0,2.936,2.30617,3.58838,3.45928s4.40392,1.48253,4.40392,1.48253,3.91462,1.812,4.89326,2.80036c.722.72918,6.683,2.62331,13.75426,4.09607l-.00133.00056s-5.709,13.14377,3.60415,12.05852,13.85037-5.6675,20.41737-5.6675c2.62415,0,7.498-.36592,12.40462-.80523a32.71024,32.71024,0,0,1,3.64663.86014,46.65449,46.65449,0,0,0,8.48164,1.812s7.33986,3.95348,11.25444,2.96512a2.56885,2.56885,0,0,0,.88945-.47561c.02935-.00678.06026-.01128.08922-.01859a5.23066,5.23066,0,0,0,2.35753-2.02123c4.89916.50042,10.47724,1.21378,12.57663,2.02445,4.0596,1.5676,33.07375-.60292,33.07375-.60292s18.7458.36855,24.11879,1.99306,3.46261-16.58388-6.44759-18.63382a40.41681,40.41681,0,0,0-8.06292-.7131,17.68246,17.68246,0,0,0,1.87294-2.277c3.57145-.32489,5.91725-.52512,5.91725-.52512s9.46028-4.61236,14.84285-7.41275a33.852,33.852,0,0,0,9.13405-7.248s4.73015-2.96508,6.68744-4.11817,2.93594-4.94183,2.93594-4.94183C270.46142,757.77908,232.78342,762.22672,232.78342,762.22672Zm-42.47564-42.15406c.00154-.55481.00339-1.10962.00553-1.66125C190.83463,718.78794,190.75811,719.37692,190.30778,720.07266Zm.155,11.64985c.3945.52015.77859.994,1.05424,1.34744,1.05423,1.35186-.85418,2.00943-.71576,4.27667.03108.5093.07452,1.21326.12308,1.99762H190.924C190.72321,736.09752,190.5595,733.40282,190.46281,731.72251Z",
  transform: "translate(-28 -62.64432)",
  fill: "url(#acac56ab-bcae-42fb-a182-d934e873c548)"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M105.559,783.70961S96.425,781.5892,92.18416,779.6319s-28.05461-5.70878-33.27407,5.54568,7.17676,26.26042,10.27582,27.8915S102.46,792.35434,102.46,792.35434l23.81379,10.03116,4.567-15.57684Z",
  transform: "translate(-28 -62.64432)",
  fill: "#65617d"
});

var _ref47 = /*#__PURE__*/React.createElement("rect", {
  x: 87.6297,
  y: 724.16434,
  width: 103.61574,
  height: 36.04691,
  rx: 16.58821,
  fill: "#65617d"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M219.24545,804.83047a18.02638,18.02638,0,0,1-18.02184,18.02673H133.6528a18.02427,18.02427,0,0,1,0-36.04854h67.57081a18.02377,18.02377,0,0,1,18.02184,18.02181Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M162.82987,805.88482s-10.38779,2.66831-18.86518,2.54891-48.1403,16.35778-48.1403,16.35778-5.709,13.01459,3.60415,11.94,13.85038-5.6118,20.41738-5.6118,27.22317-2.2686,27.22317-2.2686l19.87916-14.68618Z",
  transform: "translate(-28 -62.64432)",
  fill: "#fbbebe"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M169.33434,683.07185,150.696,686.74668l-1.20862.23977s-14.73355-3.9146-15.22288-4.24247c-.48932-.32294-13.86257-18.34967-13.86257-18.34967s6.76247.07341,12.07653-2.98976c.19084-.10764.37679-.22507.56273-.34254a11.75729,11.75729,0,0,0,5.04-6.15568c.093-.26912.17615-.548.25446-.83676a16.537,16.537,0,0,0-.15659-8.02493c-1.80071-7.60409,2.37321-9.69839,7.93683-9.51734,8.0347.26422,18.976,5.2798,18.976,5.2798a22.27606,22.27606,0,0,0,1.71754,7.43774c.08807.2202.18591.44038.28378.66548a21.22647,21.22647,0,0,0,9.89906,10.38348c.19571.09784.38656.19571.58717.28868.59209.28382,1.21844.55294,1.86922.7976C193.63908,666.76266,169.33434,683.07185,169.33434,683.07185Z",
  transform: "translate(-28 -62.64432)",
  fill: "#fbbebe"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M167.09322,649.91032a23.49289,23.49289,0,0,1-29.012,4.996,15.7895,15.7895,0,0,0,.09787-8.86169c-4.40392-18.59433,26.91285-4.23754,26.91285-4.23754A22.56713,22.56713,0,0,0,167.09322,649.91032Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M172.97491,633.39071a23.36333,23.36333,0,0,1-3.5574,12.42886,23.08761,23.08761,0,0,1-2.60807,3.42527,23.376,23.376,0,0,1-15.90305,7.58943c-.46977.02936-.94443.044-1.41906.044a23.48758,23.48758,0,1,1,23.48758-23.48758Z",
  transform: "translate(-28 -62.64432)",
  fill: "#fbbebe"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M169.33434,683.07185,150.696,686.74668l-1.20862.23977s-14.73355-3.9146-15.22288-4.24247c-.48932-.32294-13.86257-18.34967-13.86257-18.34967s6.76247.07341,12.07653-2.98976c.19084-.10764.37679-.22507.56273-.34254a21.871,21.871,0,0,0,15.89815,6.95332,22.6232,22.6232,0,0,0,3.31761-.26423c2.6228-.40125,5.26514-.66061,7.9026-.93463,5.04984-.52845,12.77626-2.06,16.83278-6.52267.19571.09784.38656.19571.58717.28868.59209.28382,1.21844.55294,1.86922.7976C193.63908,666.76266,169.33434,683.07185,169.33434,683.07185Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M190.3753,730.69779c.16148,3.59166,2.77446,44.03921,2.77446,44.03921H111.75552l.55294-25.46444.44527-20.37058.1468-6.68416.65081-23.15974-2.35365-2.07473L98.38227,685.67993l.0049-.00487c.09787-.30338,3.577-10.61345,3.09254-12.06186-.48933-1.468,6.19973-7.33987,8.48487-7.66771a28.81474,28.81474,0,0,0,3.82652-1.16459c3.84608-1.35054,8.97912-3.3372,9.54673-3.02892.7976.4306,8.80294-.31318,9.14058-.34743h.00979a21.82442,21.82442,0,0,0,16.45109,7.58942,22.62177,22.62177,0,0,0,3.31761-.26422c2.6228-.40125,5.26514-.66061,7.9026-.93463,5.30429-.55294,13.5543-2.21662,17.42-7.21264a24.72341,24.72341,0,0,1,5.456,1.1695,32.07953,32.07953,0,0,0,7.99068,1.09608,40.4481,40.4481,0,0,1,6.19973,2.28024,42.95505,42.95505,0,0,0,5.87189,2.28517s3.75312.97864,4.73176,10.43727c.97865,9.46355,1.9573,14.84612,1.9573,14.84612L190.3753,709.49538S190.21381,727.11106,190.3753,730.69779Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref55 = /*#__PURE__*/React.createElement("polygon", {
  points: "70.382 696.273 73.234 700.84 83.92 704.606 91.26 691.216 84.493 686.649 73.644 682.409 67.446 685.997 70.382 696.273",
  fill: "#fbbebe"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M189.55975,781.42609s15.16907-1.14175,21.36718-8.15541,21.8565-10.76514,21.8565-10.76514,37.678-4.40392,22.83514,28.87015c0,0-.97865,3.75149-2.93594,4.89325s-6.68744,4.0777-6.68744,4.0777L188.1024,795.2905Z",
  transform: "translate(-28 -62.64432)",
  fill: "#65617d"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M219.24545,804.83047a17.96684,17.96684,0,0,1-2.99957,9.96267c-9.73757.86608-31.307,2.89189-35.81856,4.14946-5.544,1.53649-16.76427-1.14013-17.99245-1.44351-.07341-.01467-.11256-.02446-.11256-.02446s-2.16281-6.56183-3.19528-10.76025c-.46486-1.90837-.69973-3.3274-.39635-3.43017.97865-.32783,9.95285-2.77446,9.78649-1.38969C168.35569,803.28421,195.43,791.374,195.43,791.374l.83181,10.44058C199.02164,804.98053,219.24545,800.29935,219.24545,804.83047Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M247.137,796.10583l-1.14176,4.24081a33.77859,33.77859,0,0,1-9.13406,7.17676c-5.38257,2.77284-14.84285,7.33987-14.84285,7.33987s-34.742,2.93595-40.61394,4.567-18.105-1.468-18.105-1.468-4.567-13.8642-3.58838-14.19041,9.9496-2.77284,9.7865-1.38642S196.4103,791.865,196.4103,791.865Z",
  transform: "translate(-28 -62.64432)",
  fill: "#65617d"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M150.41229,832.6719s17.07418,1.194,21.13378,2.7462,33.07376-.597,33.07376-.597,18.74578.36492,24.11878,1.97346,3.46259-16.42085-6.4476-18.45064-23.88.95519-23.88.95519-15.76079-2.02979-17.67118-2.26859-14.50458.11627-14.50458.11627Z",
  transform: "translate(-28 -62.64432)",
  fill: "#fbbebe"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M83.30955,787.65815s22.56658,2.02979,28.77538,5.73119Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M224.082,772.85256s-17.67118,4.2984-24.59637,10.62659Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M84.623,782.524c.3582.1194,10.38779,1.4328,10.149,2.388S84.623,782.524,84.623,782.524Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M68.85969,807.68651l1.30487,4.89325a21.13338,21.13338,0,0,1,3.58838,3.42527c.65243,1.14176,4.40392,1.468,4.40392,1.468s3.91459,1.79419,4.89324,2.77284,11.58068,4.07771,21.53028,5.38257,28.38083,3.75149,32.29543,5.05636a47.06421,47.06421,0,0,0,8.48162,1.79419s7.33987,3.9146,11.25447,2.93595,10.602-18.75745,10.602-18.75745-25.77109-6.035-26.58663-7.9923-25.608-11.086-25.608-11.086l-14.67974.34741Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M67.881,808.17584l1.30487,4.89324a21.13354,21.13354,0,0,1,3.58838,3.42528c.65243,1.14175,4.40392,1.468,4.40392,1.468s3.91459,1.79419,4.89324,2.77284,11.58069,4.0777,21.53029,5.38257,28.38082,3.75149,32.29542,5.05635a47.06322,47.06322,0,0,0,8.48162,1.79419s7.33987,3.9146,11.25447,2.93595,10.602-18.75744,10.602-18.75744-25.77109-6.035-26.58663-7.9923S102.46,792.35434,102.46,792.35434L91.0424,789.74461Z",
  transform: "translate(-28 -62.64432)",
  fill: "#65617d"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M101.23358,684.0505l-2.85131,1.63108-5.5027,37.51489s-2.90575,2.77284-1.9977,4.567-.17577,4.89324-.17577,4.89324-4.90928,2.12041-3.81963,3.42528.59237,3.75148-.15784,5.38257-1.97392,4.567,0,5.05635.33945,6.85054.33945,6.85054,6.88428-.78231,6.37863,3.26217c-.20392,1.63108,7.78687,6.85054,7.78687,6.85054s-9.08045-16.47393,11.25976-14.19041l1.74875-9.28785s1.74875-5.22878,0-6.85986.39305-9.37872.39305-9.37872l.38417-33.68185Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M96.80174,732.4954c.3582.597,11.343,1.81489,12.05939,3.773S96.80174,732.4954,96.80174,732.4954Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M93.33914,741.80859s1.48947-4.65659,5.04313-3.82079S93.33914,741.80859,93.33914,741.80859Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M91.42875,748.61439s2.62679-6.2088,6.20879-5.7312S91.42875,748.61439,91.42875,748.61439Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M210.92693,748.47824l-1.14176,6.85054s-11.74379,21.53028-13.8642,21.8565-13.70108-14.35352-13.70108-14.35352l-3.09906-14.35352,12.20066-2.31238,5.415-5.35371S210.4376,742.117,210.92693,748.47824Z",
  transform: "translate(-28 -62.64432)",
  fill: "#fbbebe"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M205.38125,689.59618l4.40392,3.09906v16.47392s3.42527-.32621,2.60973,1.468-2.44662,2.77284-.97865,4.40392,1.14176,4.73014-.16311,5.05635-3.58838,1.63108-1.468,2.44663,3.42527,2.28351,3.42527,3.26216a5.858,5.858,0,0,1-.65243,3.58838c-.81554,1.14176-1.63108,3.75149-.65243,4.73014s-.81554,6.035-.81554,6.035,3.09905,7.9923.1631,10.27582c0,0-1.30486,4.567-1.468,4.89324,0,0,2.05549-15.87922-18.46368-9.16292,0,0-.38178-6.05088-.5202-8.29584s1.77-2.89607.71576-4.23463-3.69259-4.40443-2.44662-5.21946.81554-2.28351.32622-3.42527-2.21678-1.14159-.65354-2.52818,2.48562-2.688,1.56958-3.342-2.50959-2.7786-1.24226-3.75316,1.30487-15.16906,1.30487-15.16906S195.59476,679.32036,205.38125,689.59618Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M203.30643,717.66055s6.27108-1.70087,6.47874,0S203.30643,717.66055,203.30643,717.66055Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M196.26184,722.34641s8.59679-2.1492,9.67139-.4776S196.26184,722.34641,196.26184,722.34641Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M194.35144,726.88361s12.89519-1.791,13.731.8358S194.35144,726.88361,194.35144,726.88361Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M196.26184,732.4954c.4776.1194,12.41759.9552,12.65639,3.2238S196.26184,732.4954,196.26184,732.4954Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref75 = /*#__PURE__*/React.createElement("rect", {
  x: 72.33957,
  y: 677.20367,
  width: 102.2521,
  height: 58.07855,
  rx: 10.46684,
  fill: "#3f3d56"
});

var _ref76 = /*#__PURE__*/React.createElement("circle", {
  cx: 123.46562,
  cy: 706.24294,
  r: 3.77153,
  fill: "#e7effd"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M117.46593,704.252s9.79971,7.49124,17.37764,1.78245C134.84357,706.0344,122.033,707.19964,117.46593,704.252Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M167.09322,706.26541s9.79972,7.49124,17.37764,1.78245C184.47086,708.04786,171.66025,709.2131,167.09322,706.26541Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M172.97491,633.39071a23.36333,23.36333,0,0,1-3.5574,12.42886c-.19571-6.54227-1.73709-13.08454-5.29449-18.54541-3.25889-5.00579-13.16281-13.77937-19.9742-11.33765a4.83512,4.83512,0,0,0-2.97511,3.20018c-.67527,2.564,1.30159,3.63081,2.569,5.67128a17.3655,17.3655,0,0,1,2.37321,11.71933,16.50191,16.50191,0,0,1-.34253,1.62456c-1.07162,4.02224-3.528,8.62677-.99332,11.92971,1.76646,2.29983,5.56362,3.09253,6.07741,5.9453a3.47849,3.47849,0,0,1,.04895.8074c-.11747,1.91814-1.75669,3.61122-2.47112,5.5-.84162,2.22153-.367,4.42839.504,6.6597,1.13524,2.91149,2.94085,5.85724,3.37632,8.93018.43061,3.02892-.504,5.92571-1.61966,8.82253a39.53786,39.53786,0,0,0-2.69128,8.30383c-.78781,5.42172,1.19885,11.69-2.21173,15.97646a2.38469,2.38469,0,0,1-1.49243,1.008c-2.1873.23-1.81541-3.6993-3.5721-5.02048.18595,2.28514.36213,4.66325-.46483,6.80159-.83186,2.13838-2.9849,3.94886-5.25048,3.59166q-.389-2.56161-.778-5.12811a14.78943,14.78943,0,0,1-5.43153,3.40081A39.58943,39.58943,0,0,1,134.47,700.33031c-5.74466,2.7647-9.09166,8.754-12.08142,14.38126-1.86433,3.51824-3.79227,7.36433-3.14146,11.29362.26423,1.6001.95419,3.12189,1.10588,4.73665s-.43551,3.49379-1.93774,4.11034a3.50215,3.50215,0,0,1-3.78247-1.17439c-.05384-.06361-.10766-.12723-.16148-.19574a3.822,3.822,0,0,1-.25936-.367,5.69922,5.69922,0,0,1-.43547-.77311,14.99247,14.99247,0,0,1-.91994-2.99957l-.10277-.4404c-1.51689-6.6695-2.887-13.5445-1.77625-20.28738.41105-2.48578,1.1597-4.94709,1.07163-7.4671a13.81017,13.81017,0,0,0-.85142-4.16415c-1.331-3.72865-3.895-7.15882-5.35811-10.91683a.59853.59853,0,0,1-.03426-.08318c-.76824-1.99156-1.145-4.47733.274-6.07254a12.362,12.362,0,0,1,2.72554-1.84476c2.83808-1.84963,4.11034-5.35808,4.629-8.70507a29.33427,29.33427,0,0,0,.3572-4.58007c3.84608-1.35054,8.97912-3.3372,9.54673-3.02892.7976.4306,8.80294-.31318,9.14058-.34743a11.96057,11.96057,0,0,0,5.60277-6.49822c.093-.26912.17615-.548.25446-.83676a23.49037,23.49037,0,1,1,34.63927-20.67886Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M145.77271,637.17191c-1.07322,4.02366-3.52685,8.62755-.991,11.93072,1.767,2.30171,5.5632,3.09111,6.07352,5.94766.4038,2.2603-1.60807,4.15926-2.42016,6.30693-1.9375,5.124,3.11139,10.16276,3.87876,15.58677.83249,5.8843-3.4549,11.2481-4.30947,17.12922-.78765,5.4206,1.19932,11.688-2.21273,15.973a2.369,2.369,0,0,1-1.492,1.00953c-2.1867.23214-1.81582-3.69641-3.5736-5.01767.189,2.28525.36559,4.66308-.46351,6.801s-2.9839,3.94834-5.24891,3.5908l-.77849-5.13a14.8446,14.8446,0,0,1-5.43226,3.40224,39.61227,39.61227,0,0,1,5.66679-15.3496c-5.742,2.76587-9.09041,8.75215-12.07877,14.38155-1.86676,3.51656-3.79267,7.36277-3.14241,11.29064.26521,1.602.95391,3.12159,1.10563,4.73833s-.43632,3.49331-1.93883,4.10923a3.55914,3.55914,0,0,1-3.94312-1.36689,10.31354,10.31354,0,0,1-1.61406-4.14222c-1.55821-6.80812-3.017-13.83774-1.87851-20.72849.41074-2.48612,1.15877-4.948,1.06852-7.46626-.19739-5.50742-4.261-10.02168-6.24486-15.16317-.76857-1.99186-1.14251-4.477.27437-6.07406a12.45122,12.45122,0,0,1,2.72868-1.84362c2.8366-1.8504,4.11031-5.35684,4.62975-8.70355a30.16516,30.16516,0,0,0-.30737-10.89628c-1.14563-5.36488-3.77188-10.60041-3.12214-16.04764.639-5.35695,4.30926-9.7722,6.77659-14.56986a34.49021,34.49021,0,0,0,3.495-20.146c-.42538-3.21719-1.16691-6.94052,1.01417-9.34346,2.6191-2.88548,7.69-1.80022,10.67871-4.30084,1.45828-1.22012,2.16683-3.09247,3.24932-4.65565a11.40677,11.40677,0,0,1,12.18842-4.35175c2.05359.58888,3.89782,1.75724,5.92936,2.41818,2.86718.93282,5.95407.81292,8.94788,1.17064s6.16482,1.36556,7.88843,3.83943c.915,1.31335,1.32849,2.91458,2.16827,4.27728,1.79993,2.92073,5.23669,4.32689,7.83688,6.56507a15.213,15.213,0,0,1,4.28225,16.24954c-1.55264,4.324-5.14482,8.14507-4.8392,12.7292.12555,1.88313.92615,3.72957.66754,5.59908-.71857,5.19456-8.26368,6.23367-10.86788,10.78536.20727-7.4634-1.22463-15.1539-5.29855-21.41079-3.26022-5.0072-13.16452-13.78029-19.9736-11.33872a4.83715,4.83715,0,0,0-2.97635,3.20075c-.67394,2.56383,1.30067,3.62953,2.56774,5.6729A17.24558,17.24558,0,0,1,145.77271,637.17191Z",
  transform: "translate(-28 -62.64432)",
  fill: "#3f3d56"
});

var _ref81 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M113.78094,663.03553a30.14531,30.14531,0,0,0-.65039-6.9839c-.974-4.5611-3.011-9.02918-3.20245-13.61286-.26144,5.10174,2.12476,10.03408,3.20245,15.08084A30.10106,30.10106,0,0,1,113.78094,663.03553Z",
  transform: "translate(-28 -62.64432)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.22,700.067c.39692-.72855.80907-1.44871,1.25151-2.15062-5.742,2.76586-9.09041,8.75214-12.07877,14.38156-1.7287,3.2565-3.50406,6.79592-3.24136,10.4209.218-3.11069,1.74684-6.13758,3.24136-8.95293C125.15636,708.55989,128.23214,703.05415,133.22,700.067Z",
  transform: "translate(-28 -62.64432)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.32661,729.5745a3.46047,3.46047,0,0,1-1.90948,2.86168,3.55915,3.55915,0,0,1-3.94312-1.36691,10.3134,10.3134,0,0,1-1.61405-4.14221,73.76365,73.76365,0,0,1-2.27137-14.81c-.10922,5.44627,1.04743,10.93036,2.27137,16.278a10.31341,10.31341,0,0,0,1.61405,4.1422,3.55913,3.55913,0,0,0,3.94312,1.36691c1.50253-.61593,2.09056-2.4925,1.93884-4.10923C120.349,729.72094,120.33572,729.64809,120.32661,729.5745Z",
  transform: "translate(-28 -62.64432)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.3034,632.26787a16.31787,16.31787,0,0,1-.52887,3.46792c-.7956,2.98275-2.34779,6.28393-2.06562,9.13813.21659-2.48306,1.40329-5.18694,2.06562-7.67015A16.53883,16.53883,0,0,0,146.3034,632.26787Z",
  transform: "translate(-28 -62.64432)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.56061,610.49329a33.8651,33.8651,0,0,0-.28062-5.20514c-.16809-1.27122-.383-2.62083-.45-3.93741a29.44437,29.44437,0,0,0,.45,5.40538A33.70664,33.70664,0,0,1,120.56061,610.49329Z",
  transform: "translate(-28 -62.64432)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M150.85707,655.08215c-.00717-.04-.02138-.07565-.0298-.11489-.34693,1.698-1.74525,3.24775-2.39036,4.95384a7.00226,7.00226,0,0,0-.40038,3.19223,6.72729,6.72729,0,0,1,.40038-1.72425C149.249,659.24141,151.26089,657.34244,150.85707,655.08215Z",
  transform: "translate(-28 -62.64432)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.05,698.7323c-.19738-5.50741-4.261-10.02165-6.24486-15.16318a10.18266,10.18266,0,0,1-.63773-2.50773,8.45247,8.45247,0,0,0,.63773,3.97571c1.95079,5.05586,5.90412,9.50736,6.2233,14.89089C112.05167,699.5305,112.0643,699.1323,112.05,698.7323Z",
  transform: "translate(-28 -62.64432)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.12561,624.85943c-3.26023-5.00718-13.16455-13.78026-19.97361-11.33869a4.83714,4.83714,0,0,0-2.97635,3.20074,3.46729,3.46729,0,0,0-.05131,1.71548c.01672-.08228.02882-.162.05131-.2475a4.83711,4.83711,0,0,1,2.97635-3.20074c6.80906-2.44158,16.71338,6.3315,19.97361,11.33869,3.68968,5.66677,5.20711,12.50931,5.30752,19.29421C169.54148,638.36266,168.08169,630.93537,164.12561,624.85943Z",
  transform: "translate(-28 -62.64432)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.292,635.48489c-.717,5.18321-8.22991,6.22972-10.84987,10.75627q.00161.74953-.018,1.49706c2.60419-4.5517,10.14933-5.59082,10.86788-10.78536a6.37813,6.37813,0,0,0,.00508-1.53822C180.29417,635.43809,180.29527,635.46144,180.292,635.48489Z",
  transform: "translate(-28 -62.64432)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.4637,617.1566c-1.55264,4.324-5.14484,8.14506-4.83922,12.72919.00448.06735.01544.13428.02157.20154.33724-4.03559,3.41034-7.54353,4.81765-11.46275a14.38346,14.38346,0,0,0,.79835-5.5868A14.13032,14.13032,0,0,1,184.4637,617.1566Z",
  transform: "translate(-28 -62.64432)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.79347,708.61012a2.369,2.369,0,0,1-1.492,1.00953c-2.1867.23215-1.81579-3.69639-3.57358-5.01766.043.52014.08395,1.04525.114,1.57107,1.62247,1.40555,1.32384,5.14131,3.45961,4.91457a2.36911,2.36911,0,0,0,1.492-1.00953c1.94649-2.4445,2.13551-5.53435,2.08536-8.74393C147.82872,704.00921,147.44106,706.541,145.79347,708.61012Z",
  transform: "translate(-28 -62.64432)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.26438,711.403c-.82911,2.1379-2.98389,3.94835-5.24889,3.59079q-.38927-2.565-.77849-5.13a14.84407,14.84407,0,0,1-5.16019,3.29712c-.09829.523-.19523,1.04644-.27208,1.5731a14.845,14.845,0,0,0,5.43227-3.40225q.38922,2.565.77849,5.13c2.265.35755,4.41978-1.45289,5.24889-3.59079a11.56634,11.56634,0,0,0,.603-4.64166A9.8719,9.8719,0,0,1,140.26438,711.403Z",
  transform: "translate(-28 -62.64432)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.00621,692.6371a26.26938,26.26938,0,0,0-.19849,4.15663,21.471,21.471,0,0,1,.19849-2.68866c.81451-5.60552,4.74419-10.74142,4.39019-16.30564C152.08029,682.8085,148.74865,687.52765,148.00621,692.6371Z",
  transform: "translate(-28 -62.64432)"
}));

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M766.99548,268.48617v98.1837c0,5.18218-4.998,9.39557-11.16946,9.39557H519.42074c-6.17143,0-11.1694-4.21339-11.1694-9.39557v-98.1837c0-5.19134,4.998-10.48215,11.1694-10.48215H755.826C761.99745,258.004,766.99548,263.29483,766.99548,268.48617Z",
  transform: "translate(-28 -62.64432)",
  fill: "#fff"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M766.99548,269.17349v27.39115H508.25134V269.17349a11.166,11.166,0,0,1,11.1694-11.16947H755.826A11.166,11.166,0,0,1,766.99548,269.17349Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff",
  opacity: 0.2
});

var _ref84 = /*#__PURE__*/React.createElement("circle", {
  cx: 494.4413,
  cy: 214.64001,
  r: 7.46895,
  fill: "#fff"
});

var _ref85 = /*#__PURE__*/React.createElement("circle", {
  cx: 516.17172,
  cy: 214.64001,
  r: 7.46895,
  fill: "#fff"
});

var _ref86 = /*#__PURE__*/React.createElement("circle", {
  cx: 537.90214,
  cy: 214.64001,
  r: 7.46895,
  fill: "#fff"
});

var _ref87 = /*#__PURE__*/React.createElement("circle", {
  cx: 688.03623,
  cy: 273.03875,
  r: 29.19937,
  fill: "#007aff"
});

var _ref88 = /*#__PURE__*/React.createElement("rect", {
  x: 530.6033,
  y: 316.03515,
  width: 123.13906,
  height: 4.34608,
  transform: "translate(1156.34565 573.77206) rotate(-180)",
  fill: "#007aff"
});

var _ref89 = /*#__PURE__*/React.createElement("rect", {
  x: 530.6033,
  y: 326.62873,
  width: 123.13906,
  height: 4.34608,
  transform: "translate(1156.34565 594.95922) rotate(-180)",
  fill: "#007aff",
  opacity: 0.2
});

var _ref90 = /*#__PURE__*/React.createElement("rect", {
  x: 530.6033,
  y: 337.22231,
  width: 123.13906,
  height: 4.34608,
  transform: "translate(1156.34565 616.14638) rotate(-180)",
  fill: "#007aff",
  opacity: 0.2
});

var _ref91 = /*#__PURE__*/React.createElement("rect", {
  x: 530.6033,
  y: 347.81589,
  width: 123.13906,
  height: 4.34608,
  transform: "translate(1156.34565 637.33354) rotate(-180)",
  fill: "#007aff",
  opacity: 0.2
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M672.56791,514.2916s-8.67612-1.99219-14.35451,3.85217c0,0,3.65479,3.29952,12.24008-.35273Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M673.51392,514.21818s5.13069,7.27462,1.8733,14.74389c0,0-4.43821-2.1323-4.31081-11.46129Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M679.30129,503.23214s-3.07626-6.66717-17.71346,1.39478c0,0,1.58047,4.45235,7.80174,4.51771S677.43644,506.51341,679.30129,503.23214Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M680.23731,502.82963s7.33472-.341,6.92229,16.36442c0,0-4.67984.64834-7.60388-4.84334S678.18407,505.99643,680.23731,502.82963Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M685.3701,489.8243s-3.33115-11.61783-18.7241-4.54636c0,0,2.69234,10.63521,16.94478,8.30323Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M691.06929,473.17452s-6.94838-11.97819-21.34471-2.25556c0,0,4.07205,11.08026,19.90049,6.26987Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M693.79,457.147s-8.29752-11.12906-22.569-1.51551c0,0,7.91614,9.81133,22.38844,4.20508Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M696.24553,441.57152s-8.38305-11.60466-22.062-2.06879c0,0,9.6388,10.39687,21.88928,4.64143Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M696.3614,427.60093s-8.63879-14.79341-21.44424-6.02113c0,0,9.4739,12.85257,21.26363,8.7107Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M695.23105,411.19734s-9.23132-14.71573-21.76449-4.75052c0,0,11.228,12.97036,21.59174,7.32316Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M692.81393,396.44s-11.15768-13.99353-22.03547-9.438c0,0,11.611,14.84671,22.30819,12.98078Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M689.53036,382.38792s-12.832-17.07189-21.26194-12.23455c0,0,9.39942,13.2,22.0593,15.34219Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M684.5269,366.00532S673.24631,352,664.13915,354.67751c0,0,9.48876,14.38061,21.7437,15.55593Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M680.02957,350.69354s-12.59982-13.53234-18.59592-11.70314c0,0,8.76357,14.68432,18.99215,14.54891Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M675.577,336.53363s-10.56391-15.86239-16.95709-15.117c0,0,6.11326,13.919,16.855,16.63724Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M670.98917,317.54084s-9.45585-12.25339-14.98478-12.59635c0,0,7.03931,15.98426,15.15218,16.39553Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M668.36131,304.92078,660.09763,280.168s-1.95778,21.74216,9.22212,29.30588Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M666.13391,278.08581s-.28652-20.22328.87585-21.78974c0,0-8.18981,16.2476-1.40531,30.68155Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M685.77,489.58034s10.67692-5.66339,16.26679,10.32729c0,0-9.5261,5.4415-17.73717-6.43909Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M691.43994,472.54978s12.95563-4.88964,17.96543,11.74423c0,0-10.15921,6.012-19.38378-7.72071Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M694.31,458.151s9.71094-9.91979,22.569,1.51551c0,0-9.15682,8.66488-22.74966,1.17406Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M696.55247,441.59214s9.85929-10.3797,22.14055.89941c0,0-10.9423,9.01485-22.31331,1.67322Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M696.33451,428.00126s7.4629-15.42007,20.91141-7.66959c0,0-8.44633,13.55-20.52231,10.337Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M694.43089,411.06352s7.44052-15.69741,21.05658-7.27194c0,0-9.6282,14.19843-20.5831,9.80653Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  d: "M691.45357,396.43212s3.70737-17.50909,15.47339-18.3088c0,0-3.7305,18.47494-14.13027,21.59841Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  d: "M689.22987,382.39846s2.408-21.22054,12.12665-21.32367c0,0-1.41163,16.143-11.23878,24.40667Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  d: "M683.56415,365.32857s4.07355-17.51589,13.43936-19.06209c0,0-2.29665,17.07525-12.82319,23.45935Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  d: "M678.92657,350.74807s1.33667-18.44161,7.15541-20.7743c0,0,2.37462,16.93489-5.68058,23.24013Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  d: "M675.16061,336.29918s2.066-18.94581,8.08343-21.23032c0,0,.98843,15.17017-7.29232,22.53245Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  d: "M670.07163,318.99857s1.0727-15.44047,5.48321-18.79218c0,0,3.00729,17.20479-3.51549,22.04639Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  d: "M668.90383,304.19353l5.77974-25.44765s4.09458,21.44269-6.284,30.07313Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  d: "M669.82763,278.57925s11.57005-16.58907,11.48514-18.53784c0,0-2.32175,18.04625-16.02943,26.19905Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  d: "M668.95144,273.39159s11.4718-23.89739,16.04894-25.587c0,0-14.51054,6.191-16.82039,24.83036Z",
  transform: "translate(-28 -62.64432)",
  fill: "#007aff"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  d: "M671.19921,321.48818l.6846-.16051c-6.4742-27.588-7.38394-44.98171-2.56135-48.977l-.44853-.5415C663.762,276.04416,664.56607,293.22292,671.19921,321.48818Z",
  transform: "translate(-28 -62.64432)",
  fill: "#444053"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  d: "M689.77594,386.29424l1.01575-.28488c-.71173-2.53607-1.49232-5.11256-2.32043-7.65783-7.20411-22.14544-13.22343-42.70044-16.9123-58.42l-.83461-.4921c3.69556,15.74808,9.53062,37.065,16.74386,59.23846C688.29174,381.20941,689.06827,383.772,689.77594,386.29424Z",
  transform: "translate(-28 -62.64432)",
  fill: "#444053"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  d: "M658.86794,533.69442c.1447-.14068,14.59643-14.3656,25.6963-39.5685a152.54193,152.54193,0,0,0,12.22263-46.48671c1.991-20.05647-.71861-42.78331-6.5754-63.65291l-.84661.86629c13.14594,46.84273,4.06958,85.61833-6.06246,108.649-10.98614,24.97239-25.27214,39.04567-25.41517,39.18473Z",
  transform: "translate(-28 -62.64432)",
  fill: "#444053"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  d: "M1092.8242,778.98846l-27.67165-40.118s-.51724-9.93276-2.32752-12.2547-.38792-7.48181-.38792-7.48181,1.9396-2.83792.2586-3.09592-.2586-6.57884-.2586-6.57884l-.12932-10.06175s1.55168-9.67476.25864-11.9967a3.80389,3.80389,0,0,1,.12928-4.12791s1.55168-5.54685,0-6.96582-1.16376-10.06175-.77584-16.89857-2.71544-10.70674-2.71544-11.73872-10.2152-11.09371-10.2152-11.9967-6.46537-4.64389-10.34457-5.67585-5.8188-1.806-5.68948-2.32194-6.0774-2.57994-6.0774-2.57994-5.43088-.387-7.4998-3.09593c-2.03975-2.67073-8.39621-3.49328-8.57511-3.51593-.03911-.18083-.08367-.36068-.11952-.541q-.06066-.29179-.11734-.583c.48878-.81865.94177-1.6611,1.351-2.52843q.18411-.39033.35629-.78721a10.994,10.994,0,0,0,6.36322-1.97321,8.66186,8.66186,0,0,0,3.09853-6.18658,13.576,13.576,0,0,0-1.51152-6.8743c-1.13493-2.32291-2.7985-4.72927-2.223-7.24884.2486-1.08851.9008-2.04344,1.23384-3.10927a8.18673,8.18673,0,0,0-.928-6.1097c-.98031-1.87434-2.34357-3.52108-3.43228-5.33493a20.92128,20.92128,0,0,1-2.72964-7.546,11.71088,11.71088,0,0,0-1.00958-4.10712,7.61937,7.61937,0,0,0-2.26748-2.29039,22.65916,22.65916,0,0,0-13.89883-4.21421c-3.51988.12209-7.0284,1.06966-10.524.64041a38.52624,38.52624,0,0,1-6.14441-1.608c-4.33682-1.28223-9.33953-1.81142-13.11607.67213-3.84407,2.52791-5.28035,7.36328-7.83914,11.18167-2.26345,3.37774-5.57659,6.20869-7.30225,9.78689.02046-.0689.03741-.13946.05825-.20814a11.75527,11.75527,0,0,0-.96374,2.60642c-.65878,2.80958-.111,5.75136.5725,8.55508.3525,1.44594.83371,3.01552,2.08867,3.81982,1.28186.82151,3.03077.62244,4.52051.8871-.05867.24541-.12061.48955-.17308.7373a29.53549,29.53549,0,0,0,20.501,34.45273c.00635.26348.01137.52606.00824.78276a20.25645,20.25645,0,0,1-.13576,2.21745l-.0009.00059-.00076-.00153s-13.0001-2.67188-16.49139-.86591-10.34452,3.22491-11.379,4.25689-3.62056.258-5.94808,6.32084-2.58616,12.2547-5.5602,15.09262-4.52572,4.77287-4.655,6.83684.38792,2.57992-.77584,3.22491-2.84477,3.35392-2.32752,4.38588c0,0,.64651,2.58-1.42236,3.86991a4.3106,4.3106,0,0,0-1.81033,3.8699s-.77584,2.83795-2.58612,3.48291-2.974,4.90189-2.974,4.90189l-5.86516,6.74148L903.10111,682.8368a4.90491,4.90491,0,0,0-6.91575-.35555l-5.70472,5.13322a11.26189,11.26189,0,0,0-5.71094,3.39816,14.848,14.848,0,0,0-2.95926,4.40348l-3.12562,2.81251a7.93188,7.93188,0,0,0-.80079,8.76628l7.44525,8.23453.0456.06857a13.11681,13.11681,0,0,0-7.2011,2.933c-11.11785,9.80245-11.24968,18.83481-9.56617,22.96012,1.67973,4.12921,15.7729,19.99581,15.7729,19.99581s8.18458,10.6428,20.00734,16.30306l-.01629.01653c-.02974.03078-.05962.05941-.08931.09084-.2344.24771-.46549.519-.69307.80918-.06336.08068-.127.16014-.1896.2443-.06062.08163-.12009.1674-.17995.25233-.07131.101-.1421.20344-.21209.30926q-.0826.125-.1637.2546c-.0753.11978-.14917.24348-.22257.36923-.04773.08189-.09574.16265-.14262.24711-.08983.16168-.1773.3299-.26376.50129-.02818.05591-.05754.10849-.08533.16543-.11034.22607-.21707.46156-.32078.70452-.03618.0847-.07027.17422-.1056.261-.06809.1677-.13528.33758-.2.51327-.04006.10874-.07879.22039-.11743.33226q-.08559.24754-.16621.50561c-.03756.11987-.075.23974-.11091.363-.05365.18415-.10417.37452-.154.56644-.03031.11663-.06213.23-.091.34957q-.10825.44914-.20235.92536c-.02339.11917-.04294.24527-.06492.36713-.0393.21832-.07785.438-.11232.665-.02316.15238-.04347.30952-.0644.46589-.02822.2113-.05474.42553-.0787.64423-.01781.162-.03466.3252-.05.4913-.02216.23958-.04044.48539-.05739.73364-.01023.15079-.022.299-.03031.453-.02187.40534-.03845.81921-.046,1.24749-.25988,15.09262.62454,17.28688.62454,17.28688s1.82714,4.80641,6.86233,5.15084a8.9572,8.9572,0,0,0,2.21113-.12c6.72268-1.161,22.49936-3.8699,28.05829-2.83664,3.34382.61917,9.53118-.298,13.93794-1.13q.60618-.11373,1.16187-.224l.80491,2.5653,2.559-.70031c.82712.47965,1.56233.90493,2.16969,1.2537.58178.33663,1.04821.60458,1.36927.78841,2.55406,8.65258,12.91009,5.70143,12.91009,5.70143l2.45935,1.42024,24.95493.6424s5.3572,3.22751,8.83295,4.24142a7.877,7.877,0,0,0,1.253.27477,57.33139,57.33139,0,0,0,6.95539.13157c1.91246-.05031,3.39041-.13157,3.39041-.13157s-.25447-6.77457-.61644-14.36078c9.53619-.39533,17.99462-.99357,23.11458-1.89281,13.32452-2.34027,18.8852-14.4606,20.934-20.9353a61.01008,61.01008,0,0,1,1.30677,8.0356,58.06412,58.06412,0,0,0,2.06892,6.96583,23.57574,23.57574,0,0,0,2.84476,5.15989c9.82728-3.35393,3.87921-8.3848,1.81028-10.57776s1.42236-3.99889,1.42236-3.99889,2.71544-1.806,2.45684-3.48291-.38792-3.48292,8.40492-3.35393S1092.8242,778.98846,1092.8242,778.98846ZM956.28551,696.62035c.11223.73829,1.33821,8.68438,2.44761,10.77489a14.22336,14.22336,0,0,1,.29113,4.249c-5.20841-.41528-10.63565-.6371-10.63565-.6371a1.243,1.243,0,0,1,.27773.66257c-.26442-.05749-.53775-.11872-.81827-.184-.38584-.08957-.7855-.18759-1.19056-.2919l9.60178-14.59613Zm-19.016,30.2521,9.01914,1.428.75643.11961a29.88883,29.88883,0,0,0-.46672,4.25855c.02676.13355.20334.29743.493.4819a11.79018,11.79018,0,0,0-.17511,2.13447c.143.71344,4.36135,2.255,9.196,3.53454-.06563.26063-.13169.50795-.19827.7403l-.00038-.00019c-4.271-2.24843-10.99748-3.29716-11.77332-4.96509s-23.66312-9.667-23.66312-9.667-.83721-.44309-2.2796-1.13863l6.03075,1.13992,1.65567-.168A90.23877,90.23877,0,0,0,937.26947,726.87245Z",
  transform: "translate(-28 -62.64432)",
  fill: "url(#af87c047-8598-4a2f-9e25-5794c516a383)"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  d: "M1063.39283,784.59856s-3.5883,21.658-21.78612,24.8618-78.94262,2.56307-78.94262,2.56307-34.72962-4.998-47.28867-34.34516-20.63273-41.00916-9.86783-41.52177,68.81848,19.6075,72.15048,19.86381S1066.59667,711.42285,1063.39283,784.59856Z",
  transform: "translate(-28 -62.64432)",
  fill: "#65617d"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  d: "M1063.39283,784.59856s-3.5883,21.658-21.78612,24.8618-78.94262,2.56307-78.94262,2.56307-34.72962-4.998-47.28867-34.34516-20.63273-41.00916-9.86783-41.52177,68.81848,19.6075,72.15048,19.86381S1066.59667,711.42285,1063.39283,784.59856Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.05
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  d: "M900.48781,808.69144s1.81084,4.775,6.80113,5.11717a8.85636,8.85636,0,0,0,2.19141-.11918c6.66274-1.15338,22.29873-3.84461,27.80808-2.81811,3.314.61513,9.44618-.296,13.81365-1.12261,2.9027-.546,5.02493-1.05727,5.02493-1.05727s-5.12489-17.04316-5.76691-17.55834c-.63827-.51132-23.06765-13.96745-23.06765-13.96745l-17.75827-1.27641-.05383-.00385a9.3531,9.3531,0,0,0-6.02062,3.53705c-1.87622,2.2683-3.48324,5.99373-3.5909,12.09512C899.61127,806.51153,900.48781,808.69144,900.48781,808.69144Z",
  transform: "translate(-28 -62.64432)",
  fill: "#3f3d56"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  d: "M900.48781,808.69144s1.81084,4.775,6.80113,5.11717a73.22769,73.22769,0,0,1-4.825-7.03948l.09612-12.42962a21.89753,21.89753,0,0,1,6.97412-18.45027l-.05383-.00385s-9.354.6382-9.61152,15.63217S900.48781,808.69144,900.48781,808.69144Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.05
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  d: "M977.52991,781.52158l16.53182-12.94094,26.01643-25.632s-2.81038-.13457-7.051-.31911c-1.05342.67281-4.01,2.78734-4.11761,5.35554-.12685,3.13336-7.03175.21914-10.6188,2.01072-3.587,1.79545-21.14535,24.26334-24.221,24.11724-3.07569-.14994-5.50936-1.56091-6.7934.619-.02694.05-.06157.09611-.09226.14225Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  d: "M903.45973,779.42244q.88228.42674,1.79155.8189c12.56031,5.38245,28.06564,16.65867,29.219,18.7117.7036,1.24565,9.69224,6.705,16.63178,10.79567,2.9027-.546,5.02493-1.05727,5.02493-1.05727s-5.12489-17.04316-5.76691-17.55834c-.63827-.51132-23.06765-13.96745-23.06765-13.96745l-17.75827-1.27641-.05383-.00385A9.3531,9.3531,0,0,0,903.45973,779.42244Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  d: "M868.6006,742.691c1.66475,4.10222,15.63224,19.86511,15.63224,19.86511s8.8426,11.53383,21.4029,16.91628,28.06564,16.65867,29.219,18.7117c.742,1.3187,10.74951,7.347,17.80441,11.48769.5459.31911,1.07261.63052,1.58008.92271,1.38025.80351,2.58361,1.50324,3.49863,2.02995,1.15338.66895,1.84928,1.065,1.84928,1.065s4.29055-3.44478,8.56575-6.91262c4.21757-3.42169,8.41585-6.86262,8.48118-7.05485.1269-.38446,1.79165-4.74426,1.40719-4.998-.19993-.13455-1.08036-1.90693-2.69893-3.96379a18.13646,18.13646,0,0,0-6.52813-5.394c-5.89382-2.69122-8.45814-8.8195-8.45814-8.8195s-.56135-.40755-1.411-.94579a17.13447,17.13447,0,0,0-5.76306-2.56819c-2.82188-.35372-8.07368-6.12063-8.07368-6.12063s-3.5908-2.30677-4.998-5.25173c-1.34561-2.81041-21.22222-16.46261-23.0638-17.72363L965.231,774.882l11.53,7.40855,16.53182-12.94094,26.01643-25.632s-3.49854-.16916-8.585-.38831c-12.645-.54592-35.10129-1.40329-37.93481-.76507a21.61993,21.61993,0,0,1-7.051.46136s-6.39748.28834-10.6304-1.94537-10.89941-3.27562-11.66833-4.93264-23.45211-9.60385-23.45211-9.60385-30.88376-16.40109-41.90622-6.66269C867.06276,729.61937,866.9321,738.59269,868.6006,742.691Z",
  transform: "translate(-28 -62.64432)",
  fill: "#65617d"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  d: "M968.176,648.62886l3.97151,13.19855,5.12489,29.73034,18.83858,1.28411,5.45548-9.04635,5.44008-9.02331s3.391-12.0144,5.82849-23.63664c2.15677-10.28433,3.56391-20.26109,1.21871-21.34528-2.0799-.96115-3.4486-4.42514-4.33673-8.14672-.11151-.46136-.21532-.93039-.30759-1.3956a72.59328,72.59328,0,0,1-1.24949-9.55384s-39.47257-2.04918-33.96321,14.22505a25.90005,25.90005,0,0,1,1.48781,8.65422,20.17122,20.17122,0,0,1-.13455,2.20295A18.45233,18.45233,0,0,1,968.176,648.62886Z",
  transform: "translate(-28 -62.64432)",
  fill: "#ee8e9e"
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  d: "M959.97162,646.449l1.41094,22.42558,3.20259,19.09619,3.5908,8.84259,3.20259,48.38054s30.89911,3.57165,38.41529-.06535a3.28671,3.28671,0,0,0,1.361-1.06112c9.07716-13.706,6.10144-53.40544,6.10144-53.40544l3.46015-25.632-2.30677-13.30233-5.57468-.59206-4.29064-.45751s-.96881,1.19182-2.36825,3.04107c-3.79847,5.01721-10.788,14.88249-10.319,19,.63826,5.64005-.76892,11.407-2.94878,12.30274-2.17987.89965-3.97152,2.4375-4.356.89965s-.76892-1.9223-.38446-4.10219-1.6685-8.8426-1.6685-8.8426-3.46014-7.81609-3.20259-11.14936-.38446-7.1779-1.41094-8.07368c-1.02272-.8958-2.43366-1.79545-1.28028-5.89379,1.15338-4.10219-5.05567-12.0836-5.05567-12.0836Z",
  transform: "translate(-28 -62.64432)",
  fill: "#e3e8f4"
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  d: "M1000.78857,702.45864l1.284,38.31922s2.9104,1.61089,7.40087,4.10219a3.28678,3.28678,0,0,0,1.361-1.06111c9.07716-13.706,6.10144-53.40544,6.10144-53.40544l3.46014-25.632-2.30676-13.30234-5.57468-.59206c2.15677-10.28433,3.56391-20.26109,1.21871-21.34527-2.0799-.96115-3.4486-4.42515-4.33673-8.14673h0l-3.99451,27.11219s.33443,2.44131.45364,4.96338a14.20458,14.20458,0,0,1-.323,4.775c-.89958,2.30677-.25756,6.409-.25756,6.409-2.31061,4.07143-3.464,11.61072-4.02914,18.89241C1000.49638,693.23158,1000.78857,702.45864,1000.78857,702.45864Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  d: "M1009.51944,620.78437s6.45655.80281,8.507,3.494,7.43291,3.07569,7.43291,3.07569,6.15137,2.05046,6.02322,2.56307,1.79415,1.28154,5.63876,2.30677,10.25229,4.74168,10.25229,5.63876,10.12413,10.893,10.12413,11.91828,3.07569,4.86984,2.69123,11.662-.76893,15.37843.76892,16.78812,0,6.9203,0,6.9203a3.7863,3.7863,0,0,0-.12816,4.10091c1.28154,2.30677-.2563,11.91829-.2563,11.91829l.12815,9.996s-1.40969,6.27952.25631,6.53583-.25631,3.07569-.25631,3.07569-1.40969,5.12614.38446,7.43291,2.30677,12.17459,2.30677,12.17459l27.42487,39.85577s.38446,7.30475-8.33,7.1766-8.58629,1.666-8.33,3.332-2.43492,3.46015-2.43492,3.46015-3.46015,1.79415-1.40969,3.97276,7.94552,7.1766-1.79415,10.5086a23.43574,23.43574,0,0,1-2.81938-5.12615,57.79109,57.79109,0,0,1-2.05046-6.92029s-.89707-9.73967-2.69122-11.02121-1.53785-7.43291-1.53785-7.43291,2.56308-4.998-1.02522-7.04845-55.61867-30.885-55.61867-30.885l-1.28153-38.31792s-.89708-28.322,4.48537-37.80532c0,0-.64077-4.10091.25631-6.40768s-.12815-9.73967-.12815-9.73967Z",
  transform: "translate(-28 -62.64432)",
  fill: "#3f3d56"
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  d: "M975.93272,636.15986s-12.88416-2.6544-16.34431-.86025-10.25229,3.20384-11.27752,4.22907-3.5883.25631-5.89506,6.27953-2.56308,12.17459-5.51061,14.994-4.48538,4.74168-4.61353,6.79214.38446,2.56307-.76892,3.20384-2.81938,3.332-2.30677,4.35722S955.872,698.73565,955.872,698.73565s1.28154,8.58629,2.43492,10.7649-1.28153,32.16655-3.84461,34.217S971.763,745.579,971.763,745.579s.89708-19.67478,1.666-20.7-.51262-22.04242-.51262-22.04242-.12815-17.9415,1.53785-22.68318,1.47849-20.50458,1.47849-20.50458,1.47306-9.45954,3.26319-11.662S975.93272,636.15986,975.93272,636.15986Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  d: "M975.54826,635.7754s-12.88417-2.6544-16.34431-.86025-10.25229,3.20384-11.27752,4.22907-3.5883.25631-5.89507,6.27953-2.56307,12.17459-5.5106,14.994-4.48538,4.74168-4.61353,6.79214.38446,2.56307-.76892,3.20384-2.81938,3.332-2.30677,4.35722,26.65595,23.58027,26.65595,23.58027,1.28154,8.58629,2.43492,10.7649-1.28153,32.16655-3.84461,34.217,17.30074,1.86143,17.30074,1.86143.89708-19.67478,1.666-20.7-.51262-22.04242-.51262-22.04242-.12815-17.9415,1.53785-22.68319,1.47849-20.50457,1.47849-20.50457,1.47306-9.45954,3.26319-11.662S975.54826,635.7754,975.54826,635.7754Z",
  transform: "translate(-28 -62.64432)",
  fill: "#3f3d56"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  d: "M974.19667,624.91917a25.90005,25.90005,0,0,1,1.48781,8.65422,29.38947,29.38947,0,0,0,33.72489-13.32543,72.59328,72.59328,0,0,1-1.24949-9.55384S968.68731,608.64494,974.19667,624.91917Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref143 = /*#__PURE__*/React.createElement("path", {
  d: "M954.71982,604.66961a29.33,29.33,0,1,0,.63827-6.1014A29.3472,29.3472,0,0,0,954.71982,604.66961Z",
  transform: "translate(-28 -62.64432)",
  fill: "#ee8e9e"
});

var _ref144 = /*#__PURE__*/React.createElement("path", {
  d: "M935.88,672.59231l-7.04845,2.17861s.64077,2.56308-1.40969,3.84461a4.28742,4.28742,0,0,0-1.79415,3.84461s-.76892,2.81938-2.56307,3.46015-2.94753,4.86983-2.94753,4.86983l-5.89507,6.79215s-2.17861,1.79415-1.79415,2.69122-2.30676,1.15338-2.30676,1.15338l1.40969,22.81134L923.7054,726.545l7.56106-.76892,6.15138-2.30677,5.38245-3.20384,2.43492-6.27952,10.7649-16.40366Z",
  transform: "translate(-28 -62.64432)",
  fill: "#3f3d56"
});

var _ref145 = /*#__PURE__*/React.createElement("path", {
  d: "M911.91527,703.221s-15.63474-22.555-27.29672-10.38044,4.74168,31.91025,8.58629,31.26948,22.17058-1.666,22.17058-1.666Z",
  transform: "translate(-28 -62.64432)",
  fill: "#ee8e9e"
});

var _ref146 = /*#__PURE__*/React.createElement("rect", {
  x: 858.90508,
  y: 672.36406,
  width: 81.83276,
  height: 63.53929,
  rx: 1.54384,
  transform: "translate(390.39207 -394.70976) rotate(27.0358)",
  fill: "#3f3d56"
});

var _ref147 = /*#__PURE__*/React.createElement("rect", {
  x: 865.53949,
  y: 678.13705,
  width: 68.78342,
  height: 51.83148,
  transform: "translate(390.36728 -394.76849) rotate(27.0358)",
  fill: "#007aff"
});

var _ref148 = /*#__PURE__*/React.createElement("circle", {
  cx: 838.90788,
  cy: 624.55625,
  r: 1.1281,
  fill: "#e6e8ec"
});

var _ref149 = /*#__PURE__*/React.createElement("circle", {
  cx: 905.22498,
  cy: 658.53563,
  r: 1.85984,
  fill: "#e6e8ec"
});

var _ref150 = /*#__PURE__*/React.createElement("path", {
  d: "M901.79113,707.96271c-.1269,16.91627,34.859,20.50327,34.859,20.50327l8.93871,1.41867,4.0023.63437,1.6685-16.53182s-1.83384-.273-4.12526-.80736c-3.38708-.78816-7.77379-2.153-8.69261-4.06375C936.904,705.91352,901.918,691.04643,901.79113,707.96271Z",
  transform: "translate(-28 -62.64432)",
  fill: "#ee8e9e"
});

var _ref151 = /*#__PURE__*/React.createElement("path", {
  d: "M955.35809,598.56821a3.4768,3.4768,0,0,1,2.14523.96116c.99193,1.04959,1.04576,2.91037,2.3337,3.55626a2.59886,2.59886,0,0,0,1.53015.17686c3.40636-.48058,5.3786-4.329,8.65036-5.3863a8.69479,8.69479,0,0,1,5.73233.49212,4.27024,4.27024,0,0,1,1.89926,1.21873c1.09566,1.41867.32673,3.50244.83425,5.21714.70359,2.37981,3.54472,3.32557,6.00527,3.637s5.23251.4844,6.87417,2.34135a6.23,6.23,0,0,1,1.22255,4.95956A3.89494,3.89494,0,0,0,992.57,617.576c.67665,1.9223,4.00225,1.6378,4.87113.11918.63433-1.1034.4421-2.01842,1.9377-2.326a6.36869,6.36869,0,0,1,3.13717.5421,23.03313,23.03313,0,0,0,8.116,1.24565,29.35124,29.35124,0,1,0-55.27389-18.5887Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref152 = /*#__PURE__*/React.createElement("path", {
  d: "M992.56907,616.80885a3.94564,3.94564,0,0,1,.01519-1.83582,6.23239,6.23239,0,0,0-1.21965-4.95831c-1.64278-1.85935-4.41532-2.03291-6.87683-2.3442s-5.30015-1.25438-6.00472-3.63336c-.50794-1.71507.2604-3.80224-.83387-5.21718a4.22832,4.22832,0,0,0-1.89741-1.21883,8.70615,8.70615,0,0,0-5.73438-.49548c-3.27162,1.058-5.24519,4.90736-8.64984,5.38831a2.60514,2.60514,0,0,1-1.52955-.17741c-1.289-.64632-1.34372-2.50573-2.33363-3.55427-1.55557-1.64771-4.508-.58307-6.41448-1.80786-1.24379-.799-1.72074-2.35837-2.07009-3.79485-.6774-2.78539-1.2203-5.70795-.56734-8.49917,1.11523-4.76727,5.37306-8.03527,8.09406-12.1055,2.536-3.79345,3.95945-8.5972,7.76921-11.10859,3.74286-2.46731,8.701-1.9416,12.99911-.66774a38.10909,38.10909,0,0,0,6.08961,1.59745c3.46446.42645,6.94169-.51493,10.43019-.63622a22.41941,22.41941,0,0,1,13.77493,4.18666,7.56148,7.56148,0,0,1,2.24725,2.2754,11.65718,11.65718,0,0,1,1.00057,4.0803,20.81653,20.81653,0,0,0,2.70525,7.49663c1.079,1.802,2.43012,3.438,3.40172,5.30006a8.15028,8.15028,0,0,1,.9197,6.06976c-.33006,1.05886-.97645,2.00754-1.22284,3.08894-.57034,2.50311,1.07839,4.89373,2.20321,7.20146a13.51422,13.51422,0,0,1,1.498,6.82936,8.61245,8.61245,0,0,1-3.07092,6.14615,11.03483,11.03483,0,0,1-6.49724,1.9689,23.0451,23.0451,0,0,1-8.27715-1.24257,6.408,6.408,0,0,0-3.13725-.54163c-1.49644.30706-1.30442,1.22264-1.93824,2.32741C996.57066,618.44485,993.24826,618.72947,992.56907,616.80885Z",
  transform: "translate(-28 -62.64432)",
  fill: "#3f3d56"
});

var _ref153 = /*#__PURE__*/React.createElement("path", {
  d: "M976.761,782.2905l16.53182-12.94094,26.01643-25.632s-3.49854-.16916-8.585-.38831a5.61743,5.61743,0,0,0-1.81469,3.50244c-.12685,3.13336-7.03175.21914-10.6188,2.01072-3.587,1.79545-21.14535,24.26334-24.221,24.11724-3.07569-.14995-5.50936-1.56091-6.7934.619-.02694.05-.06157.09611-.09226.14225A3.647,3.647,0,0,1,965.231,774.882Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref154 = /*#__PURE__*/React.createElement("path", {
  d: "M943.4398,781.39472,951.748,807.911l1.30337,4.16372,3.95222-1.08418,8.72344-2.39519,38.84209-10.66878a33.7014,33.7014,0,0,0,13.97919-3.72947,42.34964,42.34964,0,0,1,24.13689-5.26251c5.13533.48085,10.84432-1.73553,15.58153-10.48867,0,0,10.76491-31.77952-16.40491-40.8797-27.16606-9.10021-28.46549,4.8365-28.46549,4.8365s-.13845.0769-.36907.22684c-1.05342.67281-4.01,2.78734-4.11761,5.35554-.12685,3.13336-7.03175.21914-10.6188,2.01072-3.587,1.79545-21.14535,24.26334-24.221,24.11724-3.07569-.14994-5.50936-1.56091-6.7934.619-.02694.05-.06157.09611-.09226.14225-.94966,1.30717-3.80237,1.61089-5.69,1.66472-1.03038.03076-1.77626-.01539-1.77626-.01539l-.24216.073-1.97233.58824Z",
  transform: "translate(-28 -62.64432)",
  fill: "#65617d"
});

var _ref155 = /*#__PURE__*/React.createElement("path", {
  d: "M945.58888,729.88465l4.0023.63437,1.6685-16.53182s-1.83384-.273-4.12526-.80736C947.7419,715.48661,946.3655,724.40225,945.58888,729.88465Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref156 = /*#__PURE__*/React.createElement("path", {
  d: "M1050.37988,652.63653s11.91828-3.46014,8.97075,30.37241-24.98995,55.2342-24.98995,55.2342-25.37441,11.14936-36.78009,9.35521-19.73565-2.17861-19.73565-2.17861a28.97151,28.97151,0,0,0-11.53382-3.07569c-6.40768-.2563-19.86381-4.22906-20.12012-5.5106s3.332-20.12012,1.79415-21.52981c0,0,17.94151.735,19.73566,2.03352s4.35722.36752,6.27952,0,7.81737-5.49366,19.47935-1.00829c0,0,3.97276.38446,5.5106-.64076s4.0083-.25631,4.0083-.25631a11.28036,11.28036,0,0,0,2.78385-1.40969c.38446-.51262,3.46014,0,3.46014,0a1.363,1.363,0,0,0,1.92231-.89708,8.38353,8.38353,0,0,1,1.79415-2.81938s3.46014-19.47934,9.996-26.7841c0,0,1.9223-1.666,1.40969-3.71645S1035.00145,648.53562,1050.37988,652.63653Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref157 = /*#__PURE__*/React.createElement("path", {
  d: "M1050.06485,650.03728s11.91829-3.46015,8.97075,30.3724-24.98995,55.23421-24.98995,55.23421-25.37441,11.14936-36.78008,9.35521-19.73566-2.17861-19.73566-2.17861a28.97151,28.97151,0,0,0-11.53382-3.07569c-6.40768-.25631-19.86381-4.22907-20.12012-5.5106s3.332-20.12012,1.79415-21.52981c0,0,17.94151.735,19.73566,2.03352s4.35722.36751,6.27952,0,7.81737-5.49367,19.47935-1.00829c0,0,3.97276.38446,5.51061-.64077s4.0083-.25631,4.0083-.25631a11.2798,11.2798,0,0,0,2.78384-1.40969c.38446-.51261,3.46015,0,3.46015,0a1.363,1.363,0,0,0,1.9223-.89707,8.38353,8.38353,0,0,1,1.79415-2.81938s3.46015-19.47935,9.996-26.7841c0,0,1.9223-1.666,1.40969-3.71646S1034.68642,645.93636,1050.06485,650.03728Z",
  transform: "translate(-28 -62.64432)",
  fill: "#3f3d56"
});

var _ref158 = /*#__PURE__*/React.createElement("path", {
  d: "M957.50332,777.18487l16.92782,20.48024a.51539.51539,0,0,0,.10766-.11919c.1269-.38446,1.7916-4.74425,1.40714-4.998-.38446-.2576-3.32945-6.66656-9.22706-9.35778a17.52193,17.52193,0,0,1-7.24323-6.59352Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref159 = /*#__PURE__*/React.createElement("path", {
  d: "M957.73788,812.62447c1.15338.66895,1.84928,1.065,1.84928,1.065s4.29055-3.44478,8.56575-6.91262c4.21757-3.42169,8.41585-6.86262,8.48118-7.05485.1269-.38446,1.79165-4.74426,1.40719-4.998-.19993-.13455-1.08036-1.90693-2.69893-3.96379-11.47619-3.21409-4.16759,4.75193-3.19489,5.11717,0,0-13.96749-3.20641-14.73641,12.01056A17.86671,17.86671,0,0,0,957.73788,812.62447Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref160 = /*#__PURE__*/React.createElement("path", {
  d: "M971.8899,819.07188l2.43742,1.411,24.7324.6382a49.77439,49.77439,0,0,0,8.75418,4.2137,7.79121,7.79121,0,0,0,1.2418.273,56.68612,56.68612,0,0,0,6.89336.13071c1.89541-.05,3.36018-.13071,3.36018-.13071s-1.16873-31.1913-2.053-34.47461c-.42295-1.56859-2.49515-1.22259-4.54051-.43827a30.04831,30.04831,0,0,0-4.429,2.24139s-10.50735,1.01883-12.17585,1.9223c-1.66474.9035-6.40517-.519-9.354,0s-8.20058-3.46782-8.20058-3.46782c-14.3557-4.74041-6.282,4.10219-5.25555,4.48665,0,0-13.96749-3.20641-14.73641,12.01056C957.79551,823.101,971.8899,819.07188,971.8899,819.07188Z",
  transform: "translate(-28 -62.64432)",
  fill: "#3f3d56"
});

var _ref161 = /*#__PURE__*/React.createElement("path", {
  d: "M1007.64476,807.02672c.2691,6.45509,5.30168,14.47111,8.3043,18.7117,1.89541-.05,3.36018-.13071,3.36018-.13071s-1.16873-31.1913-2.053-34.47461c-.42295-1.56859-2.49515-1.22259-4.54051-.43827C1010.23217,795.3468,1007.42944,801.82113,1007.64476,807.02672Z",
  transform: "translate(-28 -62.64432)",
  fill: "#565387"
});

var _ref162 = /*#__PURE__*/React.createElement("path", {
  d: "M1007.64476,807.02672c.2691,6.45509,5.30168,14.47111,8.3043,18.7117,1.89541-.05,3.36018-.13071,3.36018-.13071s-1.16873-31.1913-2.053-34.47461c-.42295-1.56859-2.49515-1.22259-4.54051-.43827C1010.23217,795.3468,1007.42944,801.82113,1007.64476,807.02672Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref163 = /*#__PURE__*/React.createElement("path", {
  d: "M1003.41569,807.88406c1.70313,6.23211,1.68389,13.22161,4.39821,17.45068a7.79121,7.79121,0,0,0,1.2418.273,56.68612,56.68612,0,0,0,6.89336.13071c1.89541-.05,3.36018-.13071,3.36018-.13071s-1.16873-31.1913-2.053-34.47461c-.42295-1.56859-2.49515-1.22259-4.54051-.43827a30.04831,30.04831,0,0,0-4.429,2.24139S1001.23958,799.90267,1003.41569,807.88406Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.05
});

var _ref164 = /*#__PURE__*/React.createElement("path", {
  d: "M918.0886,744.65346s12.28457,3.99287,22.69516,18.15642Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref165 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M1017.91789,590.8768c-.02332.09084-.04618.18175-.07429.27183a9.06177,9.06177,0,0,1-.42712,1.06912A7.8162,7.8162,0,0,1,1017.91789,590.8768Z",
  transform: "translate(-28 -62.64432)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M948.412,584.66043a11.69365,11.69365,0,0,1,.95514-2.58938c-.06674.22015-.13319.4404-.18622.66708-.653,2.79121-.11006,5.71376.56735,8.49915.34936,1.4365.82627,2.99581,2.07,3.79486,1.90654,1.22479,4.85894.16016,6.41452,1.80787.98992,1.04853,1.04455,2.908,2.33361,3.55426a2.60476,2.60476,0,0,0,1.52953.1774c3.40468-.48092,5.37823-4.33027,8.64986-5.38829a8.706,8.706,0,0,1,5.73439.49548,4.22866,4.22866,0,0,1,1.89743,1.21882c1.09425,1.41493.32589,3.50211.83387,5.21719.70453,2.379,3.54322,3.322,6.00467,3.63334s5.23405.48485,6.87683,2.34422a6.23221,6.23221,0,0,1,1.21965,4.95831,3.94572,3.94572,0,0,0-.01516,1.83581c.67919,1.92061,4.0016,1.636,4.87255.1178.63385-1.10476.44181-2.02035,1.93826-2.32742a6.408,6.408,0,0,1,3.13726.54164,23.04526,23.04526,0,0,0,8.27717,1.24257,11.03469,11.03469,0,0,0,6.49721-1.9689,7.65632,7.65632,0,0,0,1.99378-2.42285,8.1987,8.1987,0,0,1-2.7627,4.34515,11.03477,11.03477,0,0,1-6.49721,1.96891,23.04527,23.04527,0,0,1-8.27717-1.24258,6.408,6.408,0,0,0-3.13726-.54163c-1.49645.30707-1.30441,1.22265-1.93827,2.32741-.871,1.5182-4.19335,1.80282-4.87254-.1178a3.94572,3.94572,0,0,1,.01516-1.83581,6.23225,6.23225,0,0,0-1.21965-4.95831c-1.64278-1.85936-4.41529-2.03292-6.87684-2.34421s-5.30013-1.25438-6.00466-3.63335c-.508-1.71508.26037-3.80225-.83388-5.21718a4.22855,4.22855,0,0,0-1.89743-1.21883,8.706,8.706,0,0,0-5.73438-.49548c-3.27163,1.058-5.24518,4.90737-8.64986,5.3883a2.60484,2.60484,0,0,1-1.52953-.1774c-1.28906-.64632-1.34369-2.50573-2.33361-3.55427-1.55559-1.64771-4.508-.58307-6.41452-1.80786-1.24377-.799-1.72069-2.35837-2.07-3.79486C948.302,590.37419,947.75905,587.45164,948.412,584.66043Z",
  transform: "translate(-28 -62.64432)"
}));

var _ref166 = /*#__PURE__*/React.createElement("path", {
  d: "M1019.90385,687.23229c-2.34647,3.17012-5.02735,6.10136-7.10494,9.45385s-3.54536,7.26729-3.11442,11.18774c2.14914-2.20539,3.13448-5.2532,4.48966-8.01835,2.29582-4.68445,5.72778-8.6552,8.621-12.961.55419-.82475,4.09326-5.57508,2.30235-5.8021C1023.61723,680.90479,1020.70432,686.15085,1019.90385,687.23229Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref167 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 311.5,
  cy: 523.85568,
  rx: 121,
  ry: 114,
  fill: "#f1f1f1"
});

var _ref168 = /*#__PURE__*/React.createElement("path", {
  d: "M523.12109,726.21924,423.01953,696.37549A152.88041,152.88041,0,0,1,356.5,711.5c-78.29932,0-142-58.31787-142-130s63.70068-130,142-130,142,58.31787,142,130c0,36.18652-16.61328,70.9126-45.62451,95.4751Zm-100.27832-31.9834.37452.11133,88.66162,26.43359-62.29053-43.66748,1.00732-.83691C479.76855,652.05029,496.5,617.50537,496.5,581.5c0-70.57959-62.80371-128-140-128s-140,57.42041-140,128,62.80371,128,140,128a150.82312,150.82312,0,0,0,65.9917-15.09229Z",
  transform: "translate(-28 -62.64432)",
  fill: "#2f2e41"
});

var _ref169 = /*#__PURE__*/React.createElement("circle", {
  cx: 281,
  cy: 526.35568,
  r: 11,
  fill: "#007aff"
});

var _ref170 = /*#__PURE__*/React.createElement("circle", {
  cx: 313,
  cy: 526.35568,
  r: 11,
  fill: "#007aff"
});

var _ref171 = /*#__PURE__*/React.createElement("circle", {
  cx: 345,
  cy: 526.35568,
  r: 11,
  fill: "#007aff"
});

var _ref172 = /*#__PURE__*/React.createElement("path", {
  d: "M291.73079,466.55221c6.88943,4.61571,17.33471,2.41777,17.33471,2.41777s15.77905-7.47307,20.4461-7.47307,16.0013-4.61571,16.0013-4.61571l-.38227-3.11231-1.15711-9.37612c7.182,5.59741,15.16338,3.66647,19.09634,3.257,4.22255-.43961,26.77549-13.84713,28.94454-14.72632a5.73864,5.73864,0,0,0,1.97795-1.99577h.00441a50.81013,50.81013,0,0,0,3.81812-6.9763l-.00261.0007c1.41411-1.24256,2.44461-2.24163,2.37169-2.458a15.5346,15.5346,0,0,1,1.38131-3.69068,18.08251,18.08251,0,0,0,6.84156-2.46358,6.21267,6.21267,0,0,0,.94675-.95831,6.08316,6.08316,0,0,0,1.27566-3.8772S432.631,388.305,429.7419,379.07359s7.11168-9.45122,7.11168-9.45122,15.33458-6.59387,17.46808-10.5502c1.31567-2.43534,12.81436-7.77635,21.47282-11.53047q.53985-.23414,1.06362-.45941c3.36558,7.36291,20.418,1.69805,23.7784-1.41764,3.55583-3.29693,14.00111-4.83549,14.00111-4.83549s.4445-43.07994,3.77811-48.57482c1.58234-2.60679,1.96459-11.11289,1.92455-19.32885q-.00183-.4382-.00541-.87469c4.66932-.91048,15.7729-3.0211,20.93224-3.5344,3.2699-.32531,6.6753-2.36249,9.288-4.34327.19949.24775.30763.387.30763.387a6.41832,6.41832,0,0,0,2.84333.46754,4.3998,4.3998,0,0,0,2.49044-.46754c2.00016-1.099,9.33409-3.29694,12.001-4.39591s-.44449-9.01161-2.44466-10.55019-3.3336-3.51671-2.22238-4.39591-2.66689-3.07713-4.8893-3.51671-8.88959-3.51674-8.88959-3.51674-2.44466-5.05529-6.445-5.05529-9.33409-3.95633-9.33409-3.95633c-.22225-1.75835-4.4448-1.97816-4.4448-1.97816s-16.0013-12.30855-18.66818-10.77-10.00082-2.41777-10.00082-2.41777-8.99484,1.00687-11.11162-.64911l-.00038-.01028a2.52788,2.52788,0,0,0-.53371-1.49224c-.47943-1.48529-2.80339-3.525-5.057-5.22305a19.82288,19.82288,0,0,0,.257-3.17549c0-.46158-.01779-.92316-.04887-1.37592-.00521-.07632-.01506-.15132-.02114-.22738q.15711-1.54751.3142-3.095a6.41531,6.41531,0,0,1,.77661-2.9119c.37515-.5782.92722-1.03526,1.34483-1.587a4.41542,4.41542,0,0,0,.27309-.41125c.02275-.03826.04341-.07727.06491-.116q.09066-.16333.167-.332c.01708-.03783.03491-.07536.05094-.11359a5.01031,5.01031,0,0,0,.28741-.93644c.00514-.02516.00927-.05051.014-.07574q.04155-.21792.06654-.43991l.0071-.06134a9.46325,9.46325,0,0,0-.50024-3.77415c-.66667-2.07465-1.70933-4.08418-1.82071-6.24946a19.26408,19.26408,0,0,0-.11265-3.22143c-.53482-2.4-3.008-3.93276-5.38446-4.92845-3.28537-1.37655-4.94189-2.88152-7.58158-4.92865-2.24345-1.73982-5.94288-.86628-8.76718-.685-6.44729.41382-12.814,2.35423-18.87713,4.36323a18.76623,18.76623,0,0,0-6.59492,3.27421,7.26655,7.26655,0,0,0-2.41367,4.07243l-.00015-.0006-.00046.00378a5.10726,5.10726,0,0,0-.07346,1.11014c.00143.03305.0046.066.00671.099q.01414.21322.048.42536c.00728.04624.01374.09243.02247.13854a4.53158,4.53158,0,0,0,.12321.5033l.00321.01321c.25542.80995.73115,1.54456,1.00625,2.34875a5.11112,5.11112,0,0,1,.151.54279c.00447.01958.00787.03925.01213.05887.03726.17594.06764.35253.08935.52986l.00007-.001c.245,1.999-.49155,4.08584-.81872,6.12252-.04624.28786-.07676.58145-.09989.87681l-.00013-.00113-.00053.01045a10.48144,10.48144,0,0,0,.30737,3.5095l.00961.03881c.03868.14094.08359.279.12892.41716.01953.05972.03743.12013.05824.17927.04147.1176.08784.23246.13434.34751.031.077.06146.15415.09478.22991.04519.10247.094.20255.14335.30253.04172.0846.084.16869.12871.25134.04936.091.10114.18016.15423.26865q.07817.1305.16168.25693c.05375.08126.1088.16136.166.24.06282.08659.12859.17061.19559.25387.05792.07189.11595.14341.177.21268.07463.08473.15341.16571.23279.2463.06123.06209.12142.12495.18548.18444.08883.08256.18305.15988.27745.23718.06236.05107.12252.1041.1873.15276.11041.08293.22753.15892.34512.23455.05609.03609.10892.07548.16666.10983a5.8,5.8,0,0,0,.56029.2947c1.27563.58151,2.88334.78939,3.65572,1.90958a2.50137,2.50137,0,0,1,.3743.8755c-.00087.076-.00579.15091-.00579.22708v.19341c.00888.65058.04445,1.29239.11112,1.92541a7.36562,7.36562,0,0,0,.05778,1.04182,3.00671,3.00671,0,0,0,.21778.75608,19.93744,19.93744,0,0,0,6.74032,11.32c.06427.33844.14066.73626.22766,1.18205a22.20651,22.20651,0,0,1-6.46569,3.38924c-5.33377,1.56052-12.88992,8.76545-12.88992,8.76545s-3.75589,27.03484-4.65375,30.33178c-.90227,3.29694-1.569,16.04507-1.569,16.04507s-.889,5.2751-2.22241,7.91265c-.94252,1.8602-.77353,9.84638,1.86138,14.6996a12.41327,12.41327,0,0,1-1.63913,2.66424c-5.33377,6.15427-21.335,5.93449-26.66881,5.93449-4.91363,0-6.42882,2.978-6.63756,3.44817-9.7636,2.773-41.392,11.80061-45.14439,13.44091-4.4448,1.943-6.88946,21.13554-6.88946,21.13554s-9.33406,31.87037-8.88959,36.064-3.11136,15.80772-3.11136,15.80772,0,13.14817-1.51126,14.04054a.11842.11842,0,0,1-.04443.02637c-1.55569.65939-1.33344,7.03345-1.33344,7.03345s1.14334.33087,2.92958.78306c-.47386,3.2237-2.22246,7.72895-3.60026,10.92737-.69215-.875-1.36714-1.243-1.774-.2195-1.1112,2.79579-17.77922,22.5774-22.00177,22.5774-2.01351,0-5.3382,1.64846-7.525,3.87279C289.1439,461.00018,288.12606,464.13885,291.73079,466.55221Zm76.45059-114.51349c18.89041,1.75838,39.11426-1.34075,39.11426-1.34075s-1.55567,5.51688-2.88911,7.71482-5.11154,14.72632-5.11154,17.36387-6.00047,25.27649-7.77841,26.37546a6.57939,6.57939,0,0,0-1.93349,2.79578,26.23007,26.23007,0,0,0-1.17786,3.35848c.026.57441.07944,1.11415.153,1.6278-1.32818,1.21827-2.73212,2.49151-3.98449,3.62172l.00007-.00079s-7.94731,4.42227-10.61419,6.84-15.11233,5.38058-15.11233,5.38058a77.13563,77.13563,0,0,0-8.94294,4.563c-3.856,2.32666-7.71645,5.278-8.72229,8.19543.43528-4.91188,1.14648-10.82894,1.621-14.59281.242-.00573.47917-.0152.7097-.02944,6.22715-.38683,5.29819-6.33013,4.96926-7.80274-.04445-.211-.08-.32969-.08-.32969,4.44479-4.83551,14.4456-40.882,13.11216-44.8383s1.1112-7.473,1.64013-7.473,1.249-4.39593.13779-6.81367S368.18138,352.03872,368.18138,352.03872Zm152.76127-96.9656c-.39338.0948-.78663.1897-1.17827.291-.01-.16589-.01522-.25526-.01522-.25526S520.19271,255.10843,520.94265,255.07312Zm-64.57426-33.166c-.17794.22008-.35987.43569-.54885.64128-.07461.08116-.15162.15783-.22751.2367-.00585-.41274-.00547-.82235-.00092-1.21963Q455.97535,221.74421,456.36839,221.90707Zm-22.26315,42.6424.08145,1.23706s-.12136.75333-.34545,2.04682Zm102.13223-12.2838-3.87621.6684c.55-.2075,1.09064-.43352,1.61379-.68254a3.69929,3.69929,0,0,1,1.236-.33605,6.73843,6.73843,0,0,1,1.446.30958A3.03482,3.03482,0,0,0,536.23747,252.26567Z",
  transform: "translate(-28 -62.64432)",
  fill: "url(#a0dd3877-a1bb-4f12-811d-37917980f015)"
});

var _ref173 = /*#__PURE__*/React.createElement("path", {
  d: "M405.0849,410.9551s-4.4662,9.24142-4.24807,9.8958-9.59754,8.50691-9.59754,8.50691l-10.68817-7.6344,1.09063-5.235s11.99692-10.81033,12.86943-12.058S405.0849,410.9551,405.0849,410.9551Z",
  transform: "translate(-28 -62.64432)",
  fill: "#be6f72"
});

var _ref174 = /*#__PURE__*/React.createElement("path", {
  d: "M344.12409,442.22724c7.41628,7.19816,16.14132,5.0169,20.28571,4.58064s26.27981-13.74193,28.40872-14.61443a5.66267,5.66267,0,0,0,1.94132-1.9806h.00434a50.60882,50.60882,0,0,0,3.74742-6.92331c-.14834.03927-7.40318,2.11147-9.23544-.00437,0,0-3.05377-3.743-3.70814-3.743s-.05235-6.57-.05235-6.57-7.80019,4.38869-10.4177,6.78807S360.26541,425.1,360.26541,425.1a75.37544,75.37544,0,0,0-8.77738,4.5283C345.70332,433.15755,339.90552,438.1352,344.12409,442.22724Z",
  transform: "translate(-28 -62.64432)",
  fill: "#3f3d56"
});

var _ref175 = /*#__PURE__*/React.createElement("path", {
  d: "M344.12409,442.22724c7.41628,7.19816,16.14132,5.0169,20.28571,4.58064s26.27981-13.74193,28.40872-14.61443a5.66267,5.66267,0,0,0,1.94132-1.9806c-2.58263-1.54-19.44374,9.17875-24.164,11.14189-4.71588,1.96313-16.65609.8725-23.418-1.96314-3.37659-1.41345.04361-5.76289,4.31017-9.76331C345.70332,433.15755,339.90552,438.1352,344.12409,442.22724Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref176 = /*#__PURE__*/React.createElement("path", {
  d: "M344.9966,419.54215s-3.1068,23.33947-2.31684,26.39323-19.49575-10.47-19.49575-10.47,7.09871-14.6253,5.01689-17.98551S344.9966,419.54215,344.9966,419.54215Z",
  transform: "translate(-28 -62.64432)",
  fill: "#be6f72"
});

var _ref177 = /*#__PURE__*/React.createElement("path", {
  d: "M325.58339,419.9784s12.6513,3.70814,19.63133,3.27189c6.1119-.38391,5.20012-6.282,4.8773-7.74347-.04365-.20942-.07853-.32719-.07853-.32719,4.36252-4.79877,14.17819-40.57142,12.86943-44.49769s1.09063-7.41628,1.60977-7.41628,1.22587-4.36251.13524-6.7619,4.79877-4.58064,4.79877-4.58064c18.5407,1.745,38.39016-1.33057,38.39016-1.33057s-1.52688,5.475-2.83564,7.65622-5.0169,14.61443-5.0169,17.23194-5.88939,25.08448-7.6344,26.17511a6.52966,6.52966,0,0,0-1.89771,2.77456,26.226,26.226,0,0,0-1.156,3.333c.65437,14.61443,17.23194,8.94316,19.63133,6.98a5.94628,5.94628,0,0,0,2.18126-4.79877s21.59446-22.03072,18.75882-31.192,6.98-9.37941,6.98-9.37941,15.05069-6.54378,17.14469-10.47c1.29132-2.41686,12.57715-7.7173,21.07533-11.44291,5.32227-2.33393,9.54956-4.044,9.54956-4.044l-3.538-12.68621-2.78766-9.99889-5.24812-1.97186-16.78259-6.31692-30.13192-4.14439-2.76148.35773-29.27248,3.78666s-42.75268,12.215-47.1152,14.14327-6.7619,20.975-6.7619,20.975-9.16129,31.62825-8.725,35.79009-3.05376,15.68762-3.05376,15.68762,0,13.04828-1.48327,13.93389a.11649.11649,0,0,1-.04361.02617C325.36527,413.65275,325.58339,419.9784,325.58339,419.9784Z",
  transform: "translate(-28 -62.64432)",
  fill: "#3f3d56"
});

var _ref178 = /*#__PURE__*/React.createElement("path", {
  d: "M369.4267,351.92312c18.5407,1.745,38.39016-1.33057,38.39016-1.33057,1.30875-4.12258,19.6444-15.46513,19.6444-15.46513C412.41931,331.41928,369.4267,351.92312,369.4267,351.92312Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref179 = /*#__PURE__*/React.createElement("path", {
  d: "M389.27616,407.76335c.65437,14.61443,17.23194,8.94316,19.63133,6.98a6.13275,6.13275,0,0,0,.92922-.951c-5.79344,2.13325-16.0628,3.7823-19.4045-9.362A26.226,26.226,0,0,0,389.27616,407.76335Z",
  transform: "translate(-28 -62.64432)",
  fill: "#444053"
});

var _ref180 = /*#__PURE__*/React.createElement("path", {
  d: "M325.58339,419.9784s12.6513,3.70814,19.63133,3.27189c6.1119-.38391,5.20012-6.282,4.8773-7.74347-6.40418-.20069-17.43264-.80272-23.15626-2.53462a.11649.11649,0,0,1-.04361.02617C325.36527,413.65275,325.58339,419.9784,325.58339,419.9784Z",
  transform: "translate(-28 -62.64432)",
  fill: "#444053"
});

var _ref181 = /*#__PURE__*/React.createElement("path", {
  d: "M389.27616,407.76335c.65437,14.61443,17.23194,8.94316,19.63133,6.98a6.13275,6.13275,0,0,0,.92922-.951c-5.79344,2.13325-16.0628,3.7823-19.4045-9.362A26.226,26.226,0,0,0,389.27616,407.76335Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref182 = /*#__PURE__*/React.createElement("path", {
  d: "M325.58339,419.9784s12.6513,3.70814,19.63133,3.27189c6.1119-.38391,5.20012-6.282,4.8773-7.74347-6.40418-.20069-17.43264-.80272-23.15626-2.53462a.11649.11649,0,0,1-.04361.02617C325.36527,413.65275,325.58339,419.9784,325.58339,419.9784Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref183 = /*#__PURE__*/React.createElement("path", {
  d: "M294.39139,465.56671c6.7619,4.58065,17.01382,2.39939,17.01382,2.39939s15.48694-7.41628,20.06758-7.41628,15.70507-4.58065,15.70507-4.58065l-.37517-3.08867-1.80609-14.79765s-16.98765-.43625-17.6682-1.96313c0,0-3.05376-7.51227-4.14439-4.73769s-17.45008,22.40588-21.59447,22.40588c-1.97623,0-5.23939,1.63595-7.38574,3.84338C291.8524,460.05685,290.85339,463.17169,294.39139,465.56671Z",
  transform: "translate(-28 -62.64432)",
  fill: "#3f3d56"
});

var _ref184 = /*#__PURE__*/React.createElement("path", {
  d: "M353.06726,336.6543s14.17818,8.94317,10.25191,10.9063S353.06726,336.6543,353.06726,336.6543Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref185 = /*#__PURE__*/React.createElement("path", {
  d: "M347.17786,353.88625s12.215,11.59635,7.6344,11.9057S347.17786,353.88625,347.17786,353.88625Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref186 = /*#__PURE__*/React.createElement("path", {
  d: "M334.0903,390.74953s6.2012,11.65663,3.864,13.68085S334.0903,390.74953,334.0903,390.74953Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref187 = /*#__PURE__*/React.createElement("path", {
  d: "M402.36371,402.52833c-2.18126,2.18126,20.722-7.19816,15.48694-7.63441S402.36371,402.52833,402.36371,402.52833Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref188 = /*#__PURE__*/React.createElement("path", {
  d: "M448.17015,238.9339s.25737-.03928.72853-.10906c2.7135-.41445,12.54661-1.95877,21.36761-3.87392,2.15072-.46679,4.236-.95539,6.1468-1.45709,6.75753-1.77119,11.2902-3.682,8.40221-5.2481-3.82594-2.07656-5.84142-5.85015-6.90587-9.09587-.10033-.31845-.19632-.6282-.28358-.93355a23.97447,23.97447,0,0,1-.88121-5.02127s-24.64822-8.725-19.84945,0c2.35574,4.27963.77214,7.774-1.45273,10.22138a19.14317,19.14317,0,0,1-5.30918,3.95681Z",
  transform: "translate(-28 -62.64432)",
  fill: "#be6f72"
});

var _ref189 = /*#__PURE__*/React.createElement("path", {
  d: "M474.56338,232.172s-8.81665,6.32565-17.82307,1.09063-20.78521,46.24269-20.78521,46.24269l-12.21505,30.10137s-7.91362,6.54378,1.93259,9.37942,31.69368-2.83564,37.23845,5.45314,16.04969,9.59754,17.12288,9.59754,5.22989-31.192,5.22989-31.192l1.07832-45.15206Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref190 = /*#__PURE__*/React.createElement("path", {
  d: "M426.10889,317.2411c9.84621,2.83564,31.69368-2.83564,37.23845,5.45315a21.30059,21.30059,0,0,0,9.38378,7.55151,24.57155,24.57155,0,0,0,7.7391,2.046c.144,0,.349-.57149.589-1.56179,1.53559-6.31255,4.6417-29.63022,4.6417-29.63022l1.07755-45.15206-10.36534-22.45389-1.41345-3.06684a18.78446,18.78446,0,0,1-4.49339,2.18562,15.81483,15.81483,0,0,1-13.33186-1.095c-2.64371-1.53562-5.523,1.81043-8.27571,7.30722-6.62666,13.23586-12.50733,38.93547-12.50733,38.93547l-12.215,30.10137a10.58255,10.58255,0,0,0-.82889.794C421.61114,310.48356,418.36106,315.01186,426.10889,317.2411Z",
  transform: "translate(-28 -62.64432)",
  fill: "#f3f5f9"
});

var _ref191 = /*#__PURE__*/React.createElement("path", {
  d: "M473.0234,318.75925a56.78334,56.78334,0,0,0-.29228,11.48651A134.57428,134.57428,0,0,0,474.78151,346.47a6.20523,6.20523,0,0,0,.26611.99027c5.32227-2.33393,9.54956-4.044,9.54956-4.044l-3.538-12.68621c1.53559-6.31255,4.6417-29.63022,4.6417-29.63022l1.07755-45.15206-10.36534-22.45389c6.75753-1.77119,11.2902-3.682,8.40221-5.2481-4.19674-2.27725-6.21659-6.60049-7.18945-10.02942a36.54022,36.54022,0,0,1-6.19912,6.67028c-.08725.07415-.13523.11343-.13523.11343l-.78525,7.61259-.24,2.33831-.50168,4.85548s2.39939,57.36712,4.1444,60.639.8725,9.59754-.65438,17.01382C473.16737,317.878,473.09322,318.30992,473.0234,318.75925Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref192 = /*#__PURE__*/React.createElement("path", {
  d: "M474.12713,316.58672c-1.52688,7.41628-.21812,19.63133,1.52688,29.01075s20.28571,3.27188,23.77573,0,13.74193-4.79877,13.74193-4.79877.43625-42.75268,3.70814-48.20583c1.553-2.587,1.92822-11.02846,1.889-19.182-.03051-7.32466-.39261-14.41375-.52785-16.81751-.03491-.55838-.05235-.86377-.05235-.86377s14.17819-23.99385,13.96006-25.73885-4.36252-1.96314-4.36252-1.96314-15.70506-12.21505-18.32257-10.68817-9.81567-2.39938-9.81567-2.39938-9.122,1.03391-11.00665-.72419a.95836.95836,0,0,1-.33589-.80269c.21375-2.792-9.29653-8.75558-9.58884-8.9388,8.014,7.21123-4.94708,18.32258-6.41724,19.53971-.08726.07416-.13524.11343-.13524.11343l-1.52688,14.80639s2.39938,57.36711,4.14439,60.639S475.654,309.17044,474.12713,316.58672Z",
  transform: "translate(-28 -62.64432)",
  fill: "#67647e"
});

var _ref193 = /*#__PURE__*/React.createElement("circle", {
  cx: 446.97128,
  cy: 191.6252,
  r: 1.09063,
  fill: "#444053"
});

var _ref194 = /*#__PURE__*/React.createElement("path", {
  d: "M472.73549,224.88659l6.62666,6.4129,9.71531-16.21113a.95833.95833,0,0,1-.33589-.80269c.21376-2.792-9.29653-8.75557-9.58884-8.93879C487.1667,212.55811,474.20565,223.66945,472.73549,224.88659Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref195 = /*#__PURE__*/React.createElement("circle", {
  cx: 449.15254,
  cy: 226.52535,
  r: 1.09063,
  opacity: 0.1
});

var _ref196 = /*#__PURE__*/React.createElement("circle", {
  cx: 449.15254,
  cy: 226.0891,
  r: 1.09063,
  fill: "#444053"
});

var _ref197 = /*#__PURE__*/React.createElement("path", {
  d: "M472.29924,224.01408l6.62666,6.41291,9.71531-16.21113a.95836.95836,0,0,1-.33589-.80269c.21375-2.792-9.29653-8.75558-9.58884-8.9388C486.73045,211.6856,473.7694,222.797,472.29924,224.01408Z",
  transform: "translate(-28 -62.64432)",
  fill: "#67647e"
});

var _ref198 = /*#__PURE__*/React.createElement("rect", {
  x: 465.77961,
  y: 253.19489,
  width: 15.17956,
  height: 32.07586,
  rx: 1.69947,
  transform: "translate(912.48201 486.53614) rotate(-178.69453)",
  fill: "#3f3d56"
});

var _ref199 = /*#__PURE__*/React.createElement("rect", {
  x: 465.77961,
  y: 253.19489,
  width: 15.17956,
  height: 32.07586,
  rx: 1.69947,
  transform: "translate(912.48201 486.53614) rotate(-178.69453)",
  opacity: 0.1
});

var _ref200 = /*#__PURE__*/React.createElement("rect", {
  x: 465.8605,
  y: 253.90471,
  width: 15.17956,
  height: 32.07586,
  rx: 1.69947,
  transform: "matrix(-0.99974, -0.02278, 0.02278, -0.99974, 912.6276, 487.95743)",
  fill: "#3f3d56"
});

var _ref201 = /*#__PURE__*/React.createElement("circle", {
  cx: 445.85689,
  cy: 200.64197,
  r: 2.38537,
  fill: "#67647e"
});

var _ref202 = /*#__PURE__*/React.createElement("path", {
  d: "M391.67554,314.62359c5.45315,2.39938,41.2258-3.92627,46.46082-5.45315s12.86943-13.30568,9.16129-21.81259,1.30875-16.79569,1.30875-16.79569,7.85253-16.7957,9.59754-20.06759,5.38333-12.79964,5.8894-14.39631a1.29611,1.29611,0,0,0-.30975-.999c-1.41782-2.15943-6.8884-5.981-6.8884-5.981-1.54.55839-1.73194-3.85211-1.67086-7.09345.03491-1.81483.144-3.26316.144-3.26316s-.72419.73727-1.90641,1.74064c-.43189.36207-.92486.76344-1.47017,1.17789a22.5859,22.5859,0,0,1-6.87533,3.75612c-5.235,1.54869-12.65131,8.69886-12.65131,8.69886l2.18126,33.49977s-5.01689,31.50175-10.25191,37.60927-20.94009,5.8894-26.17511,5.8894S391.67554,314.62359,391.67554,314.62359Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref203 = /*#__PURE__*/React.createElement("path", {
  d: "M391.23929,313.31483c5.45315,2.39939,41.22579-3.92626,46.46082-5.45315s12.86942-13.30568,9.16128-21.81259,1.30876-16.79569,1.30876-16.79569,7.85253-16.79569,9.59754-20.06758,5.38333-12.79964,5.8894-14.39631a1.29612,1.29612,0,0,0-.30975-.999c-1.41782-2.15942-6.88841-5.981-6.88841-5.981-1.54.55839-1.73193-3.85211-1.67085-7.09346.03491-1.81482.144-3.26316.144-3.26316s-.72419.73727-1.90642,1.74065c-.43188.36206-.92485.76344-1.47016,1.17788a22.58581,22.58581,0,0,1-6.87533,3.75612c-5.235,1.54869-12.65131,8.69886-12.65131,8.69886l2.18126,33.49977s-5.01689,31.50175-10.25192,37.60928-20.94008,5.8894-26.1751,5.8894S391.23929,313.31483,391.23929,313.31483Z",
  transform: "translate(-28 -62.64432)",
  fill: "#67647e"
});

var _ref204 = /*#__PURE__*/React.createElement("path", {
  d: "M450.56953,218.32537s.205,1.15168.54969,2.91852c1.17351,5.98973,3.97424,19.06855,5.99409,18.56251,1.44836-.36209,3.89573-2.92726,5.79778-5.14342-1.41782-2.15943-6.88841-5.981-6.88841-5.981-1.54.55839-1.73193-3.85211-1.67085-7.09346l-1.76245-1.52251Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref205 = /*#__PURE__*/React.createElement("path", {
  d: "M451.00579,217.45286s.205,1.15169.54968,2.91853c1.17352,5.98973,3.97425,19.06855,5.99409,18.56251,1.44836-.3621,3.89573-2.92726,5.79778-5.14343-1.41782-2.15942-6.88841-5.981-6.88841-5.981-1.54.55839-1.73193-3.85211-1.67085-7.09346l-1.76245-1.52251Z",
  transform: "translate(-28 -62.64432)",
  fill: "#67647e"
});

var _ref206 = /*#__PURE__*/React.createElement("path", {
  d: "M437.04573,281.68658s10.90629-2.18126,13.96006-6.98,23.82807-8.94316,21.29345-3.92627-21.29345,21.43226-21.29345,21.43226l-8.12738,11.64-10.84958-2.75275-4.5689-8.88724Z",
  transform: "translate(-28 -62.64432)",
  fill: "#be6f72"
});

var _ref207 = /*#__PURE__*/React.createElement("path", {
  d: "M462.84941,294.13107s-10.56167,3.92626-12.1518,9.16128S462.84941,294.13107,462.84941,294.13107Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref208 = /*#__PURE__*/React.createElement("path", {
  d: "M469.32836,300.22728s.961,5.45-12.27987,5.0153Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref209 = /*#__PURE__*/React.createElement("path", {
  d: "M526.47735,230.427l4.79877-.43625s5.235,3.92626,9.16129,3.92626,6.32565,5.0169,6.32565,5.0169,6.54377,3.05376,8.725,3.49,5.8894,2.61751,4.79877,3.49.21813,2.83564,2.18126,4.36252,5.0169,9.37941,2.39939,10.47-9.81567,3.27189-11.7788,4.36252a5.409,5.409,0,0,1-4.36252,0S537.1705,250.05832,531.27861,252.894s-13.96255,2.83563-13.96255,2.83563l-6.32565-13.30568Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref210 = /*#__PURE__*/React.createElement("path", {
  d: "M426.10889,302.19912a5.83122,5.83122,0,0,0,4.06587,2.82693,30.82308,30.82308,0,0,0,12.70365-1.17352s-21.974-6.98-.81579-23.9546h-5.67127l-1.889-.71543.86379-4.51993,1.24332-40.74557-4.58065-1.09063s-3.68633,26.82949-4.56757,30.10138c-.88557,3.27189-1.53995,15.92319-1.53995,15.92319s-.87251,5.235-2.18126,7.85253C422.75412,288.671,423.00715,297.54432,426.10889,302.19912Z",
  transform: "translate(-28 -62.64432)",
  fill: "#67647e"
});

var _ref211 = /*#__PURE__*/React.createElement("path", {
  d: "M426.9814,302.19912a5.83122,5.83122,0,0,0,4.06587,2.82693,30.82312,30.82312,0,0,0,12.70365-1.17352s-21.974-6.98-.81579-23.9546h-5.67128l-1.889-.71543C432.26877,284.68362,427.37837,294.47312,426.9814,302.19912Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref212 = /*#__PURE__*/React.createElement("path", {
  d: "M426.10889,302.19912a5.83122,5.83122,0,0,0,4.06587,2.82693,30.82308,30.82308,0,0,0,12.70365-1.17352s-21.974-6.98-.81579-23.9546h-5.67127l-1.889-.71543C431.39626,284.68362,426.50587,294.47312,426.10889,302.19912Z",
  transform: "translate(-28 -62.64432)",
  fill: "none"
});

var _ref213 = /*#__PURE__*/React.createElement("path", {
  d: "M426.10889,302.19912a5.83122,5.83122,0,0,0,4.06587,2.82693,30.82308,30.82308,0,0,0,12.70365-1.17352s-21.974-6.98-.81579-23.9546h-5.67127l-1.889-.71543C431.39626,284.68362,426.50587,294.47312,426.10889,302.19912Z",
  transform: "translate(-28 -62.64432)",
  fill: "#67647e"
});

var _ref214 = /*#__PURE__*/React.createElement("path", {
  d: "M455.44246,223.41642a19.85073,19.85073,0,0,0,22.467-4.26656c-.10033-.31845-.19632-.6282-.28358-.93355a23.97447,23.97447,0,0,1-.88121-5.02127s-24.64822-8.725-19.84945,0C459.25093,217.47467,457.66733,220.96905,455.44246,223.41642Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref215 = /*#__PURE__*/React.createElement("path", {
  d: "M443.80763,204.47v.19195c.00871.64564.04362,1.28258.10906,1.91078.06543.602.157,1.1997.27048,1.78426a19.85565,19.85565,0,0,0,38.24619,2.56516c.13087-.3839.253-.77217.35773-1.16478a19.7563,19.7563,0,0,0,.71546-5.28737c0-.45806-.01747-.91615-.048-1.36547A19.849,19.849,0,0,0,443.80763,204.47Z",
  transform: "translate(-28 -62.64432)",
  fill: "#be6f72"
});

var _ref216 = /*#__PURE__*/React.createElement("path", {
  d: "M443.80763,204.662a8.60057,8.60057,0,0,1,.10906,1.91078,7.391,7.391,0,0,0,.05672,1.03392,3.0087,3.0087,0,0,0,.21376.75034c.80269,1.88461,3.4202,3.10174,5.14776,1.889a5.58954,5.58954,0,0,0,1.54869-2.02859c1.83227-3.40712,4.38433-7.329,8.39785-7.39444,1.71013-.03054,3.31987.68926,4.97328,1.11243,1.649.41879,3.61652.47114,4.85112-.65437.94666-.8638,1.396-2.34267,2.66986-2.64805,1.29131-.30975,2.443.86377,3.02759,2.00674.58459,1.13861,1.047,2.48664,2.22924,3.07557.5235.26177,1.13861.33593,1.65341.61513,2.37321,1.3,1.28258,5.85449,3.74739,6.59176a1.86024,1.86024,0,0,0,.23556.05672c.03928-.40571.08289-.81579.12217-1.2215q.33373-3.32425.66747-6.65284A19.849,19.849,0,0,0,443.80763,204.47Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref217 = /*#__PURE__*/React.createElement("path", {
  d: "M479.06884,174.83987c2.33242.98814,4.75987,2.50926,5.28477,4.891a19.32963,19.32963,0,0,1,.11057,3.197c.10932,2.14883,1.13267,4.14311,1.787,6.202s.888,4.4619-.42283,6.21287c-.40988.54751-.95172,1.0011-1.31992,1.57491a6.42129,6.42129,0,0,0-.76223,2.88978l-1.078,10.73665c-2.76865-.51567-1.53625-5.31264-3.98424-6.64944-.51409-.28073-1.12684-.35586-1.65182-.61761-1.181-.58886-1.64323-1.93432-2.22932-3.0757s-1.7365-2.3132-3.02922-2.00416c-1.27017.30365-1.71961,1.78592-2.66642,2.64851-1.23616,1.1262-3.2026,1.07373-4.85413.6523s-3.26166-1.142-4.971-1.11318c-4.01462.06765-6.56727,3.98763-8.39966,7.39454a5.54876,5.54876,0,0,1-1.54828,2.03166c-1.94868,1.37067-5.027-.35486-5.36141-2.64178-.18718-1.27986.21218-2.71-.52657-3.79337-.75808-1.11169-2.336-1.318-3.588-1.89506-3.18739-1.46911-4.17609-5.449-3.64581-8.78683.38219-2.40564,1.33927-4.88233.55589-7.1979-.27-.7981-.73693-1.52713-.98763-2.33094-.70022-2.24516.44172-4.72289,2.24167-6.3168a18.34006,18.34006,0,0,1,6.47283-3.24931c5.95084-1.99374,12.19972-3.91941,18.52767-4.3301,2.772-.17991,6.403-1.04682,8.60487.67981C474.21842,171.98025,475.84428,173.47379,479.06884,174.83987Z",
  transform: "translate(-28 -62.64432)",
  fill: "#3f3d56"
});

var _ref218 = /*#__PURE__*/React.createElement("circle", {
  cx: 445.88065,
  cy: 174.39326,
  r: 1.09063,
  opacity: 0.1
});

var _ref219 = /*#__PURE__*/React.createElement("circle", {
  cx: 445.88065,
  cy: 173.95701,
  r: 1.09063,
  fill: "#444053"
});

var _ref220 = /*#__PURE__*/React.createElement("circle", {
  cx: 452.86068,
  cy: 242.88479,
  r: 1.09063,
  opacity: 0.1
});

var _ref221 = /*#__PURE__*/React.createElement("circle", {
  cx: 452.86068,
  cy: 242.44854,
  r: 1.09063,
  fill: "#444053"
});

var _ref222 = /*#__PURE__*/React.createElement("circle", {
  cx: 449.15254,
  cy: 260.98924,
  r: 1.09063,
  opacity: 0.1
});

var _ref223 = /*#__PURE__*/React.createElement("circle", {
  cx: 449.15254,
  cy: 260.55299,
  r: 1.09063,
  fill: "#444053"
});

var _ref224 = /*#__PURE__*/React.createElement("path", {
  d: "M439.66324,254.26952s-2.39939,16.29264,0,19.12827S439.66324,254.26952,439.66324,254.26952Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref225 = /*#__PURE__*/React.createElement("path", {
  d: "M510.99041,284.52221s4.58064,9.868,0,19.33032-7.41628,13.30407-5.8894,19.34478S510.99041,284.52221,510.99041,284.52221Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref226 = /*#__PURE__*/React.createElement("path", {
  d: "M294.39139,465.56671c6.7619,4.58065,17.01382,2.39939,17.01382,2.39939s15.48694-7.41628,20.06758-7.41628,15.70507-4.58065,15.70507-4.58065l-.37517-3.08867c-4.51959.87251-14.79768,2.9447-15.98428,3.96118-1.52688,1.30875-20.28571,7.6344-20.28571,7.6344s-12.77346-1.59669-16.3289-6.84479C291.8524,460.05685,290.85339,463.17169,294.39139,465.56671Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref227 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M484.464,181.18284c-.012-.23632-.012-.47351-.0085-.71088.01931.271.02288.54358.01931.817C484.47246,181.25337,484.46578,181.21852,484.464,181.18284Z",
  transform: "translate(-28 -62.64432)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M439.85791,199.73573c1.252.57708,2.82994.78339,3.588,1.89508.73876,1.08333.33941,2.51351.52657,3.79337.33446,2.28691,3.41274,4.01243,5.36142,2.64177a5.54859,5.54859,0,0,0,1.54826-2.03165c1.8324-3.40691,4.38507-7.32689,8.39968-7.39455,1.70936-.02881,3.3195.69176,4.971,1.11318s3.618.47391,4.85413-.6523c.94682-.8626,1.39625-2.34485,2.66642-2.6485,1.29273-.30906,2.44314.86278,3.02924,2.00416s1.0483,2.48683,2.2293,3.07568c.525.26177,1.13773.33691,1.65181.61763,2.448,1.3368,1.21562,6.13376,3.98426,6.64943q.53895-5.36834,1.07795-10.73665a6.42121,6.42121,0,0,1,.76222-2.88977c.36822-.57381.91005-1.02742,1.31994-1.57492a4.8039,4.8039,0,0,0,.89561-2.30853,5.58033,5.58033,0,0,1-.89561,4.05354c-.40989.5475-.95172,1.00111-1.31994,1.57492a6.42121,6.42121,0,0,0-.76222,2.88977q-.539,5.36834-1.07795,10.73665c-2.76864-.51568-1.53625-5.31264-3.98426-6.64943-.51408-.28073-1.12681-.35587-1.65181-.61763-1.181-.58885-1.64322-1.9343-2.2293-3.07568s-1.73651-2.31322-3.02924-2.00416c-1.27017.30365-1.7196,1.7859-2.66642,2.6485-1.23614,1.1262-3.20261,1.07372-4.85413.6523s-3.26166-1.142-4.971-1.11318c-4.01461.06766-6.56728,3.98764-8.39968,7.39455a5.54859,5.54859,0,0,1-1.54826,2.03165c-1.94868,1.37066-5.027-.35486-5.36142-2.64177-.18716-1.27987.21219-2.71-.52657-3.79337-.75809-1.1117-2.336-1.318-3.588-1.89508-2.91493-1.34353-3.98668-4.786-3.74376-7.91779C436.32652,196.1452,437.47956,198.63954,439.85791,199.73573Z",
  transform: "translate(-28 -62.64432)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M435.78035,181.42008c.25069.80381.71762,1.53285.98764,2.33093a6.70809,6.70809,0,0,1,.24782,2.86793,5.57361,5.57361,0,0,0-.24782-1.12292c-.27-.79809-.73695-1.52713-.98764-2.33093a4.82681,4.82681,0,0,1-.12725-2.27589A4.54106,4.54106,0,0,0,435.78035,181.42008Z",
  transform: "translate(-28 -62.64432)"
}));

var _ref228 = /*#__PURE__*/React.createElement("path", {
  d: "M499.866,278.406c5.01689-1.09936,16.79569-4.57191,16.79569-4.57191s.79832-.16141,2.10708-.42317c-.03051-7.32466-.39261-14.41375-.52785-16.81751l-.05235.00874s-10.03379,3.27189-12.43317,5.01689-9.81567,1.30876-9.81567,1.30876-11.56067.65438-21.15821,11.34255S494.84909,279.50532,499.866,278.406Z",
  transform: "translate(-28 -62.64432)",
  opacity: 0.1
});

var _ref229 = /*#__PURE__*/React.createElement("path", {
  d: "M548.89337,258.93986a2.90961,2.90961,0,0,1,.65471,4.89012c-2.65716,2.2-6.53793,4.8329-10.23991,5.20529-6.17854.62153-21.04986,3.6043-22.52767,3.90227-.08024.01618-.15514.03471-.23367.05778-1.22642.36034-11.95441,3.50214-16.68084,4.538-5.0169,1.0995-34.682,6.55265-25.08448-4.13552a33.9265,33.9265,0,0,1,20.945-11.32535,2.72428,2.72428,0,0,1,.38391-.00852c1.12193.05213,7.46122.27073,9.64495-1.31743a20.58141,20.58141,0,0,1,3.60944-1.79749,69.31068,69.31068,0,0,1,14.74625-4.252l10.26056-1.789a2.95242,2.95242,0,0,1,1.72817.22045Z",
  transform: "translate(-28 -62.64432)",
  fill: "#be6f72"
});

var _ref230 = /*#__PURE__*/React.createElement("path", {
  d: "M527.34985,230.427l4.79877-.43625s5.235,3.92626,9.16129,3.92626,6.32565,5.0169,6.32565,5.0169,6.54378,3.05376,8.725,3.49,5.8894,2.61751,4.79877,3.49.21812,2.83564,2.18126,4.36252,5.01689,9.37941,2.39938,10.47-9.81566,3.27189-11.7788,4.36252a5.409,5.409,0,0,1-4.36252,0S538.043,250.05832,532.15111,252.894s-13.96255,2.83563-13.96255,2.83563l-6.32565-13.30568Z",
  transform: "translate(-28 -62.64432)",
  fill: "#67647e"
});

function SvgUndrawGroupChatUnwm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ec16f1a7-6162-4648-9d10-380c89c40baf",
    "data-name": "Layer 1",
    width: 1144,
    height: 774.71136,
    viewBox: "0 0 1144 774.71136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group chat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, _ref220, _ref221, _ref222, _ref223, _ref224, _ref225, _ref226, _ref227, _ref228, _ref229, _ref230);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawGroupChatUnwm);
export default __webpack_public_path__ + "static/media/undraw_Group_chat_unwm.d7d23e39.svg";
export { ForwardRef as ReactComponent };